/* ==========================================================================
   CASA FLORES — comportamento do site

   PROCEDÊNCIA DOS DADOS
   Nome, preço e situação de estoque das peças vêm do levantamento do site
   atual (10-catalogo-do-site-atual.md, coleta de 13/08/2026 pela API do Wix
   Stores). São 54 peças reais; aqui entram as que a home mostra.

   O QUE NÃO É REAL, e está marcado como tal:
   · as FOTOS. O catálogo atual tem foto de vitrine, não a foto que o manual
     pede. Enquanto a produção não acontece, cada peça aponta para uma das
     imagens de processo geradas para este protótipo. Trocar em `img:`.
   · o `resumo` de cada peça, escrito a partir do nome (40-copy-e-voz §4).
   ========================================================================== */

/* build 2026-09-02a */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ dados */

  /* A regra do plano (01 §3.1): espécie NÃO é categoria, é filtro. As quatro
     categorias abaixo dizem o que a PEÇA É. Rosa e girassol viram `flor`, que
     filtra dentro delas.

     A ORQUÍDEA É A EXCEÇÃO, e ela foi aberta pelo cliente em 16/09/2026. O motivo
     do §3.1 é que quem compra flor de presente não sabe o nome da flor — sabe para
     quem é. Isso vale para rosa e girassol, que são flor de corte dentro de um
     buquê; **não vale para orquídea**, que a pessoa pede pelo nome ("quero uma
     orquídea"), é a peça inteira e não um ingrediente dela, e é por onde passa o
     "verde que fica" da casa. Some-se o fato medido: as NOVE peças desta categoria
     são orquídeas, e a foto do cartão (`cat-plantas.jpg`) já é uma phalaenopsis —
     "Plantas" prometia uma variedade que a vitrine não tem.
     O dia em que a casa mandar samambaia, zâmia ou suculenta, esta categoria volta
     a ser `plantas` e a orquídea volta a ser filtro de `flor`. É o mesmo teste do
     `aCaminho` logo abaixo: está assim porque é o negócio, ou porque só chegou
     isso? Aqui, hoje, é o negócio. */
  var CATEGORIAS = [
    /* `aCaminho` é a terceira situação de uma categoria, e ela faltava (16/09/2026).
       Havia duas no código: categoria COM peça, e `jardim`, que tem `rota` porque é
       serviço e nunca terá peça. Quando as quatro peças inventadas saíram, `buques`
       caiu num terceiro estado que eu li como o primeiro e tratei como ausente:
       recolhi o link do menu. **Errado, e o cliente corrigiu.**

       A CASA VENDE BUQUÊ. O que não existe ainda é o PRODUTO NO SITE — nome e foto
       virão dele. "Não tem peça hoje" e "não é do negócio" são coisas diferentes, e
       tirar do menu diz a segunda quando a verdade é a primeira: some do menu, some
       da home, e a loja passa a afirmar que não trabalha com buquê.

       Com `aCaminho`, a categoria fica no menu e na home, e a vitrine dela mostra a
       MOLDURA (ver `molduraDaCategoria`) em vez do vazio. No dia em que os buquês
       entrarem no `PECAS`, some esta chave — uma linha — e tudo volta ao normal. */
    { id: 'buques',    nome: 'Buquês',
      d: 'Amarrado e embrulhado na hora, com a flor que estava boa no dia.',
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-buques.jpg?v=45576225943230950741790605383' },
    { id: 'arranjos',  nome: 'Arranjos em vidro',
      d: 'Cilindro, aquário e vaso quadrado. Peça que fica em pé na mesa.',
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-arranjos.jpg?v=141308180559873442891790605383' },
    /* O ARQUIVO DA FOTO CONTINUA `cat-plantas.jpg` DE PROPÓSITO. Nome de arquivo
       não é rótulo: renomear obrigaria a subir asset novo no tema publicado, que
       deixa órfão no lugar do antigo, para trocar uma string que ninguém lê. O
       mesmo vale para `sobre-plantas.jpg` e as quatro `cuidado-plantas-*.jpg`. */
    { id: 'orquideas', nome: 'Orquídeas',
      d: 'Vaso que fica. A gente escolhe pela luz que o lugar tem.',
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-plantas.jpg?v=14236603925174453821790605383' },
    { id: 'plantas-de-chao', nome: 'Plantas',
      d: 'Planta de chão, de porte. A peça grande que muda a sala.',
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-plantas-de-chao.jpg?v=63507425450560459471790605383' }
    /* `jardim` SAIU DA GRADE em 24/09/2026, a pedido do cliente: "não tem necessidade".
       Era o único cartão que não levava a produto (serviço, com `rota` para o bloco de
       manutenção da home). O serviço continua nomeado onde ele é explicado: bloco
       "Manutenção de plantas e jardim", o FAQ e a página de assinaturas. */
  ];

  /* ------------------------------------------------ SOBRE A CATEGORIA
     O rodapé editorial da vitrine (`.sobrecat`, na /collections/all). Uma entrada por
     categoria da grade; `jardim` não entra porque é serviço e não abre
     vitrine, e "a loja inteira" não entra porque não existe cuidado comum a
     flor de corte e planta viva — que é justamente a divisão que a marca
     defende.

     O QUE ESTE TEXTO É, e o que ele não é: é a resposta à pergunta que a grade
     deixa aberta ("o que é essa peça, e o que eu faço com ela?"), na voz do
     40-copy-e-voz.md — gesto e recusa, número no lugar de formulação, sem
     verbo de venda. NÃO é aula de botânica: uma linha só entra em `cuidado` se
     muda o que a pessoa FAZ com a peça em casa.

     Os prazos são de manejo de flor de corte, não promessa comercial: por isso
     "costuma dar", e por isso nenhuma linha promete durabilidade por peça. Os
     pendentes com o cliente (horário, janela de entrega, área atendida, ano de
     fundação) continuam fora daqui de propósito — nenhum deles é necessário
     para explicar a peça, e o rótulo diz só o bairro.

     ENXUGADO EM 31/08/2026 ("está com muito texto"), de 3.329 para ~2.100
     caracteres — 37% a menos. A auditoria mediu 38, 36 e 37 linhas de texto por
     categoria, e achou quatro gorduras. As três primeiras são de redação; a
     quarta muda a REGRA de composição desta seção:

     1. O SEGUNDO PARÁGRAFO E A NOTA DIZIAM A MESMA COISA. Em buquês e arranjos
        o `corpo[1]` era a substituição da flor contada com outras palavras, e a
        `nota` logo abaixo repetia. O parágrafo saiu; ficou a nota, que é o
        texto canônico do 40-copy-e-voz.md e vale igual na página da peça.
     2. O OLHO ANTECIPAVA A COLUNA DE CUIDADO ("é peça com prazo, e o prazo se
        decide nos primeiros minutos" — a linha PRAZO ao lado diz isso).
     3. CADA LINHA DE CUIDADO TINHA REGRA + RAZÃO + REFORÇO. A razão fica: é ela
        que ensina. O reforço saiu.
     4. **`corpo` VIRA UM PARÁGRAFO SÓ, E ELE É O DO SERVIÇO — NÃO O DA
        BOTÂNICA.** Em plantas o parágrafo bom era o da Phalaenopsis em casca; e
        era justamente o dispensável, porque a coluna ao lado é a aula (Luz,
        Água, Vaso, Depois da flor). O que só o parágrafo pode dizer é por que
        se compra AQUI: "a gente escolhe pela luz que o lugar tem, não pela
        foto". Regra que fica: a PROSA vende a casa, a COLUNA ensina a peça —
        quando as duas ensinam, a prosa é a que sai.

     Tetos que a auditoria fixou, e que valem para uma categoria nova:
     olho <= 95 · corpo (um só) <= 135 · nota <= 130 · cada cuidado <= 100. */
  var SOBRE_CATEGORIA = {
    buques: {
      rotulo: 'Casa Flores · Vila Olímpia',
      titulo: 'Sobre nossos buquês',
      olho: 'Buquê é flor de corte: sai da água da loja e vai para a sua.',
      corpo: [
        'A haste é cortada na medida e a amarração é dada à mão, no mesmo dia em que a peça sai. <span class="grifo">Nada aqui sai pronto da caixa.</span>'
      ],
      nota: 'A flor é escolhida na manhã da entrega. Se alguma não estiver boa, entra outra do mesmo porte, e a gente avisa antes de montar.',
      foto: { ar: '3/2', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-sobre-buques.jpg?v=129075355216059003301788186578',
              alt: 'Na bancada de pinus da loja, o buquê de flor mista — gérbera rosa e amarela, alstroemélia, crisântemo e solidago — deitado de lado com o cone de juta ainda aberto em volta e o rolo de ráfia ao lado; ao fundo, a parede de tijolo encontrando a parede lilás e o balde de zinco.',
              brief: 'O buquê do dia deitado na bancada de madeira da loja, o papel ainda aberto e o rolo de ráfia ao lado, com a luz da janela entrando pela esquerda.' },
      cuidado: [
        ['Corte', 'Um dedo de haste, na diagonal, com lâmina afiada. Corte amassado fecha o canal e a flor não bebe.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-buques-corte.jpg?v=120300024013596586691790617028',
          alt: 'Uma mão segura o feixe de hastes em pé contra a borda do balde de zinco enquanto a outra fecha a tesoura numa delas, em diagonal; duas pontas já cortadas estão caídas na bancada.',
          brief: 'A tesoura fechada na haste, em diagonal, sobre a borda do balde de zinco, com as pontas já cortadas na madeira.' }],
        ['Água', 'Troque a cada dois dias, lavando o vaso. Tire a folha que fica submersa: ela apodrece antes da flor.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-buques-agua.jpg?v=19559914123886267341790617028',
          alt: 'Na pia de inox, uma mão inclina a jarra de vidro pela alça e despeja a água velha, esverdeada, no ralo; ao lado, um segundo vaso já lavado escorre de boca para baixo.',
          brief: 'A mão despejando a água velha na pia, com o vidro do vaso já lavado escorrendo ao lado.' }],
        ['Lugar', 'Longe do sol direto, do ar-condicionado e da fruteira: fruta madura abre a flor antes da hora.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-buques-lugar.jpg?v=57185379930254456941788186578',
          alt: 'O buquê aberto numa jarra de vidro sobre a mesa de jantar, em sombra aberta, com o retângulo de sol terminando antes de alcançá-lo e a fruteira desfocada ao fundo.',
          brief: 'O buquê na mesa de jantar, na sombra aberta, com a fruteira desfocada ao fundo e longe dele.' }],
        ['Prazo', 'Com a água trocada, costuma dar de cinco a sete dias. A rosa chega fechada e abre em casa.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-buques-prazo.jpg?v=20398376258586577601788186578',
          alt: 'Duas rosas cor-de-rosa lado a lado sobre a bancada: a da esquerda ainda em botão fechado e nítida, a da direita já aberta e fora de foco, com a borda de uma pétala externa amarronzada.',
          brief: 'A mesma rosa em dois momentos no mesmo enquadramento: fechada na chegada e aberta no quarto dia.' }]
      ]
    },
    arranjos: {
      rotulo: 'Casa Flores · Vila Olímpia',
      titulo: 'Sobre nossos arranjos',
      olho: 'Arranjo é a peça que chega em pé: o vidro é o vaso, e ele sai da loja já com água.',
      corpo: [
        'Cilindro, aquário e vaso quadrado. A flor é montada dentro do vidro, e é a peça que <span class="grifo">não precisa de arrumação na chegada</span>.'
      ],
      nota: 'A flor é escolhida na manhã da entrega. Se alguma não estiver boa, entra outra do mesmo porte, e a gente avisa antes de montar.',
      foto: { ar: '3/2', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-sobre-arranjos.jpg?v=719496918357748841788186577',
              alt: 'No balcão de pedra clara de uma recepção, o arranjo de girassóis no cubo de vidro com a água visível até dois terços e as hastes cortadas na mesma altura lá dentro; a luz da porta atravessa o vidro e deixa uma mancha clara na pedra ao lado.',
              brief: 'O arranjo em cilindro de vidro pousado no balcão de recepção, com a sombra do vidro caindo na pedra e a cáustica da água na superfície.' },
      cuidado: [
        ['Água', 'Troque a cada dois dias, lavando o vidro por dentro — água velha mancha e cheira antes da murcha.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-arranjos-agua.jpg?v=98662037711512316451790617554',
          alt: 'Na pia de inox, uma mão firma o cubo de vidro pela face enquanto a outra passa a esponja na parede interna; a faixa já esfregada aparece limpa contra o resto, e a peça montada espera apoiada na bancada.',
          brief: 'O cilindro vazio sendo lavado por dentro na pia, com a peça inteira apoiada de lado no balcão.' }],
        ['Corte', 'Na troca, corte meio dedo de haste e devolva a peça na mesma altura: o desenho não muda.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-arranjos-corte.jpg?v=76569038846812674541790617554',
          alt: 'Uma mão mantém o feixe de hastes de girassol alinhado pela ponta enquanto a outra fecha a tesoura numa delas em diagonal; o cubo de vidro com água espera ao lado.',
          brief: 'A tesoura cortando meio dedo de haste em diagonal, com o feixe alinhado pela ponta contra a borda do vidro.' }],
        ['Lugar', 'Mesa longe do sol e do ar-condicionado. Vidro no sol esquenta a água, e água quente encurta a peça.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-arranjos-lugar.jpg?v=101548383359208414731788186578',
          alt: 'O arranjo de girassóis no cubo de vidro sobre a mesa, em sombra aberta, com o retângulo de sol da tarde projetado no tampo ao lado dele e um anel de água já seco na madeira.',
          brief: 'O arranjo na mesa, com o retângulo de sol projetado no tampo ao lado dele e não sobre o vidro.' }],
        ['Poda', 'Tire uma a uma a flor que passou, sem desmontar o resto. O arranjo fica menor e continua peça.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-arranjos-poda.jpg?v=111537607863972907611790617554',
          alt: 'O indicador e o polegar pinçam a haste de um único girassol já passado e o puxam para fora do miolo do arranjo; o resto do desenho continua inteiro e uma pétala murcha boia dentro do cubo.',
          brief: 'Dois dedos puxando uma única flor passada de dentro do arranjo, com o resto do desenho intacto em volta.' }]
      ]
    },
    orquideas: {
      rotulo: 'Casa Flores · Vila Olímpia',
      titulo: 'Sobre nossas orquídeas',
      olho: 'Orquídea não é arranjo montado: é a planta inteira, com raiz, dentro do vaso.',
      corpo: [
        'A gente escolhe pela luz que o lugar tem, não pela foto. <span class="grifo">Diga onde ela vai ficar</span> e a que horas bate sol ali.'
      ],
      nota: 'Orquídea é ser vivo e responde ao lugar. Se ela começar a passar mal, mande uma foto: quase sempre é luz ou água.',
      foto: { ar: '3/2', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-sobre-plantas.jpg?v=16473369396496317621788186578',
              alt: 'Sobre a mesa de tampo preto da loja, a orquídea Phalaenopsis de flor branca salpicada de magenta no vaso plástico transparente dentro do cachepô de fibra, com a casca de pinus à mostra; atrás, a estante de pinus com outros cachepôs e a grade preta com o quintal.',
              brief: 'A orquídea Phalaenopsis no cachepô de fibra sobre a mesa preta da loja, com a luz clara da janela pela direita e a sombra da haste caindo no tampo.' },
      cuidado: [
        ['Luz', 'Clara e indireta. A folha é o medidor: verde-clara está no ponto, amarelada é sol demais.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-plantas-luz.jpg?v=58899760440071487221788186578',
          alt: 'Close de duas folhas de Phalaenopsis contra a luz: a da esquerda verde-clara e firme, nítida na nervura central; a da direita mais escura, com a borda avermelhada e ressecada de sol demais.',
          brief: 'Close de duas folhas lado a lado contra a luz: uma verde-clara e firme, a outra com a borda avermelhada de sol demais.' }],
        ['Água', 'Pelo substrato, nunca pelo calendário. Dedo na casca: úmida, espere; seca, regue até escorrer.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-plantas-agua.jpg?v=153001464168607186051790618781',
          alt: 'O indicador enfiado dois centímetros na casca de pinus do substrato, com os pedaços cedendo em volta do dedo e uma raiz esverdeada encostada na parede do vaso plástico transparente.',
          brief: 'O dedo enfiado dois centímetros na casca do substrato, com os pedaços de casca visíveis em volta.' }],
        ['Vaso', 'Cachepô é enfeite, não vaso. Água parada no fundo dele apodrece a raiz: regue e devolva escorrido.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-plantas-vaso.jpg?v=116577448792757657581790618781',
          alt: 'As duas mãos seguram o vaso plástico transparente sobre a pia e a água escorre dos furos do fundo em fios finos; o cachepô de fibra espera vazio e seco na bancada, fora do caminho da água.',
          brief: 'O vaso plástico erguido para fora do cachepô de fibra, escorrendo água pelos furos sobre a pia.' }],
        ['Depois da flor', 'A haste seca pode ser cortada rente. A próxima floração quem chama é o clima, não a tesoura.',
         { ar: '4/5', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cuidado-plantas-depois.jpg?v=524117748567608921790618780',
          alt: 'Uma mão afasta uma folha carnuda enquanto a outra fecha a tesoura na haste seca e amarronzada da orquídea, rente à base; uma folha nova, mais clara, sai da coroa logo ao lado do corte.',
          brief: 'A tesoura cortando a haste seca rente à base, com a folha nova saindo da coroa logo ao lado.' }]
      ]
    }
  };

  /* `permanencia` é o posicionamento virado atributo (01 §3.3): "flor que
     chega hoje" e "verde que fica" existem dentro do catálogo, não só na
     home. É também honestidade comercial — quem quer que dure precisa saber
     qual dura. */
  /* AS PEÇAS INVENTADAS SAÍRAM (16/09/2026, 3a rodada). O catálogo nasceu com
     oito peças de mentira — nomes montados a partir do site atual para o
     protótipo ter o que mostrar. À medida que o cliente mandou o catálogo real,
     elas foram sendo substituídas; as quatro que sobravam (`p1`, `p2` e `p7`,
     buquês, e `p4`, rosas em cilindro) foram removidas a pedido dele. Hoje
     **toda peça da vitrine é produto que a casa vende de verdade** — e é por
     isso que o aviso "as fotos não são das peças" perdeu o objeto.

     O QUE A REMOÇÃO LEVOU JUNTO, e que não é óbvio: a categoria `buques` ficou
     sem nenhuma peça, e com ela os filtros `rosa`, `girassol`, `flores do campo`
     e `flor de corte`. Eram 15 links de navegação e 5 dos 9 chips apontando para
     vitrine vazia. **Nada disso foi apagado do código** — ver `recolheVazios()`:
     menu, cartão de categoria e chips passaram a se desenhar a partir do
     catálogo, então o que não tem peça não aparece, e no dia em que os buquês
     oficiais entrarem tudo volta sozinho, sem tocar em cinco páginas. */
  var PECAS = [
    /* ---------------------------------------------- AS QUATRO OFICIAIS
       Em 16/09/2026 chegou a primeira lista de produtos que a casa vende de
       verdade — as mini orquídeas — e p3, p5, p6 e p8 passaram a ser elas.
       Três coisas mudam junto com o nome, e nenhuma é cosmética:

       · a CATEGORIA segue o produto. Mini orquídea é planta em vaso, então p3
         e p6 saem de `arranjos` e entram na categoria das orquídeas (que em
         16/09/2026 ainda se chamava `plantas`). Nome oficial pendurado
         em categoria antiga seria o mesmo defeito com outra roupa.
       · o PREÇO sai do catrálogo real levantado no doc 10 — R$ 330 no arranjo
         phala, que casa pelo nome exato, e R$ 160 nas minis de porte pequeno,
         que lá custam de 140 a 180. Os quatro estão A CONFIRMAR com a casa.
       · a FOTO não existe ainda: está sendo feita. Por isso `img` SOME em vez
         de apontar para a foto da peça antiga — mostrar UMA peça real ao lado
         do nome e do preço de OUTRA é exatamente o defeito que o comentário
         antigo desta linha descrevia. Sem `img`, o cartão desenha o molde (ver
         `figuraDaPeca`). Quando a foto chegar, volta uma linha `img:` aqui e
         nenhuma outra linha do projeto muda. */
    /* A CAPA DE ESTÚDIO CHEGOU (16/09/2026) e ela vem de um registro de luz
       DIFERENTE do da `p5`: o cliente mandou uma referência de fotografia de
       catálogo — fundo claro e quase uniforme, bancada acesa — e aprovou essa
       luz. Quando esta subiu, a `p5` ainda estava no registro antigo e a série
       ficou desigual por algumas horas; em 16/09/2026 a `p5` foi refeita aqui e
       **as três minis fecham dentro de 0,05 stop**. Doc 30 §25.9 e §27. */
    { id: 'p3', nome: 'Mini orquídea gisele', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 160,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-gisele-estudio-4x5.jpg?v=151984021247575861181789570325',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-gisele-detalhe-4x5.jpg?v=43512873934443842061789570311',
      resumo: 'Porte mini, no vaso que fica. Chega florida.' },

    /* REFOTOGRAFADA EM 16/09/2026 PARA FECHAR A SÉRIE. A primeira versão desta
       capa saiu num registro mais escuro, antes de o cliente aprovar a luz de
       catálogo que a `p3` e a `p6` usam; na grade ela destoava das vizinhas em
       0,37 stop e o cliente apontou. A versão atual foi gerada com a MESMA foto
       real dele como verdade do produto e a `p3` publicada como alvo de luz, e
       fecha a 0,05 stop da gisele e 0,03 da amarela. A anterior está guardada em
       `fotos-produto/_anterior/…-REGISTRO-ESCURO.jpg`. Doc 30 §27.
       O papel do arquivo é `estudio` e não `detalhe` de propósito: a foto crua
       tratada continua em `…-detalhe-4x5.jpg` e é o hover do cartão. */
    { id: 'p5', nome: 'Mini orquídea lilás', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 160,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-lilas-estudio-4x5.jpg?v=92727125462459899801789571951',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-lilas-detalhe-4x5.jpg?v=138598880039224908671789570311',
      resumo: 'Chega florida e volta a florir. Dura meses, não dias.' },

    /* A CAPA DE ESTÚDIO CHEGOU (16/09/2026), no mesmo registro claro da `p3`.
       A `p5` era a única fora e foi refeita no mesmo dia: as três minis fecham
       dentro de 0,05 stop uma da outra.
       Esta peça é mais ALTA que as outras duas (60,4% da altura do 9:16 do
       cliente, contra 51–52%), e por isso o 4:5 com a peça a 80% não cabia na
       largura do arquivo: a referência de enquadramento foi feita espelhando
       85px de parede e bancada em cada lateral. Doc 30 §26.1. */
    { id: 'p6', nome: 'Mini orquídea amarela', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 160,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-amarela-estudio-4x5.jpg?v=39045961656627542591789571395',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-amarela-detalhe-4x5.jpg?v=150928348148451853601789570311',
      resumo: 'Amarela e mini. Planta em vaso, não flor cortada.' },

    /* O `esgotada: true` SAIU DAQUI em 16/09/2026, e a saída é de dado, não de
       gosto: no levantamento do site atual (doc 10) o "Arranjo de Mini Orquídeas
       Phala" NÃO está entre as dez peças esgotadas. Marcar esgotado um produto
       que a casa vende seria inventar estoque, que é o oposto do que a regra do
       esgotado existia para proteger.
       O CUSTO, registrado para não se perder: a vitrine ficou sem nenhum cartão
       no estado esgotado. `.selo` e `.peca--esgotada` continuam de pé no CSS e
       sem uso — quando a casa disser o que está em falta, é uma chave
       `esgotada: true` na peça certa, e o estado volta inteiro. */
    /* A ÚLTIMA DAS QUATRO OFICIAIS A GANHAR CAPA (16/09/2026), no mesmo registro
       claro das outras três. É a peça mais larga do conjunto — 85% da largura do
       arquivo do cliente —, e por isso a referência de enquadramento não pôde ser
       feita por espelhamento como a da `p6`: o espelho trazia as pontas das sprays
       junto e criava flores fantasmas nos cantos. Foi feita por MEDIANA das faixas
       limpas. Doc 30 §28.1. */
    { id: 'p8', nome: 'Arranjo mini orquídeas phala', cat: 'arranjos',
      flor: 'orquídea', permanencia: 'planta viva', preco: 330,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-phala-estudio-4x5.jpg?v=122005584202016480361789575482',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-phala-detalhe-4x5.jpg?v=54169532118470999221789570310',
      resumo: 'Mini phalaenopsis juntas num arranjo. Em pé na mesa.' },

    /* ------------------------------- A SEGUNDA FAMÍLIA OFICIAL: AS ORQUÍDEAS
       Ainda em 16/09/2026 veio a lista das orquídeas de porte. São SETE, e
       sobravam QUATRO peças genéricas na vitrine de oito — então aqui o
       catálogo CRESCE em vez de substituir. Substituir levaria a tirar
       buquê e arranjo de rosas da vitrine para pôr orquídea, deixando a loja
       inteira de uma família só, e ainda assim faltaria slot para três.
       As quatro genéricas que sobram (p1, p2, p7 e p4) esperam as famílias
       delas — buquês e rosas — que ainda não vieram.

       A HOME NÃO MUDA, e isso é de propósito: o `data-destaques="8"` da
       `/` mostra as oito primeiras do array, ou seja as mesmas de
       antes. A home é recorte ("o que a casa montou hoje"), não índice —
       quem quer a família inteira entra por Orquídeas, que agora tem nove.

       PREÇO, de novo tirado do doc 10 e A CONFIRMAR. As de porte grande lá
       custam R$ 380 (branca, exótica, dalmata, fucsia), a magenta R$ 300, e a
       `Orquídea gisele` NÃO EXISTE no levantamento — entrou a 380 por ser o
       valor de todas as outras de porte. O arranjo é o palpite mais fraco dos
       sete: o doc 10 tem `Arranjo de Mini Orquídeas Phala` a 330, que já é o
       p8, e `Arranjo de Orquídeas` a 220, que é de onde este número saiu.

       A MAGENTA ESTÁ "ESGOTADO" NO DOC 10 E MESMO ASSIM ENTRA DISPONÍVEL. Não
       é descuido: o levantamento é uma fotografia do site do cliente feita em
       agosto, e a lista que o Erik mandou HOJE nomeia a magenta como produto
       que a casa vende. Evidência mais nova ganha da mais velha, e estoque de
       um mês atrás não é estoque. Se a casa disser que falta, é uma chave
       `esgotada: true` aqui — e o estado esgotado, que a vitrine perdeu quando
       o p8 trocou de nome, volta inteiro com ela.

       Os `resumo` usam só o que o doc 10 afirma das de porte (uma haste em
       cascalho no vaso aquário de vidro, oito botões ou mais, 30 por 75 cm) e
       deixam a COR por conta do nome, como nas minis. A `gisele` não tem
       descrição nenhuma na fonte, então o resumo dela não cita vaso nem medida.

       AS FOTOS CHEGARAM em 16/09/2026: cada uma ganhou `img2` com a foto de
       DETALHE da flor. Nenhuma tem `img` ainda -- a capa de peça inteira não
       foi feita --, e por isso `figuraDaPeca` promove a segunda a capa. Quando
       a capa vier, é uma linha `img:` aqui e o hover liga sozinho. */
    { id: 'p9', nome: 'Arranjo mini orquídeas', cat: 'arranjos',
      flor: 'orquídea', permanencia: 'planta viva', preco: 220,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-estudio-4x5.jpg?v=104542851631112063331790604536',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-detalhe-4x5.jpg?v=163572010771330984881790603238',
      resumo: 'Mini orquídeas juntas num arranjo. Chega florida.' },

    { id: 'p10', nome: 'Orquídea magenta', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 300,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-magenta-estudio-4x5.jpg?v=31233368957226641071789578145',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-magenta-detalhe-4x5.jpg?v=180984389867694006581790356448',
      resumo: 'Uma haste só. Oito botões ou mais.' },

    { id: 'p11', nome: 'Orquídea branca', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 380,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-branca-estudio-4x5.jpg?v=38156580603593769751789578146',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-branca-detalhe-4x5.jpg?v=62328580317092244111790356448',
      resumo: 'Chega florida e volta a florir. Planta que fica.' },

    { id: 'p12', nome: 'Orquídea dálmata', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 380,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-dalmata-estudio-4x5.jpg?v=174016111216004834971789578146',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-dalmata-detalhe-4x5.jpg?v=39999288677807628891790356448',
      resumo: 'Haste em cascata. Chega florida.' },

    { id: 'p13', nome: 'Orquídea exótica', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 380,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-exotica-estudio-4x5.jpg?v=162500152317758862381789578146',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-exotica-detalhe-4x5.jpg?v=49803675263918377781790356448',
      resumo: 'Uma haste selecionada. Chega florida.' },

    { id: 'p14', nome: 'Orquídea fúcsia', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 380,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-fucsia-estudio-4x5.jpg?v=34703993723956868631789578145',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-fucsia-detalhe-4x5.jpg?v=114937264819836074851790356448',
      resumo: 'Porte grande, 30 por 75. Oito botões ou mais.' },

    { id: 'p15', nome: 'Orquídea gisele', cat: 'orquideas',
      flor: 'orquídea', permanencia: 'planta viva', preco: 380,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-gisele-estudio-4x5.jpg?v=47329509116921173081789578145',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-gisele-detalhe-4x5.jpg?v=97541082103965475031790356448',
      resumo: 'Planta em vaso, não flor cortada. Dura meses.' },
    /* ------------------------------ A TERCEIRA FAMÍLIA: ARRANJOS DE FLOR DE CORTE
       24/09/2026. Seis arranjos que a casa vende, fotografados no mesmo estúdio
       claro das orquídeas (bancada de pinus mel, parede de cal cinza-pérola, luz
       2:1). Todos são flor de corte, então `permanencia` é `flor de corte` — e é
       isso que devolve à vitrine o chip "Hoje — flor de corte", que estava sem
       nenhuma peça desde que as genéricas saíram. `flor` usa os chips que já
       existem (rosa, girassol); lírio e mix ficam fora dos chips, mas a busca acha.

       PREÇO, tirado do doc 10 (site atual no Wix) e A CONFIRMAR com a casa. Cinco
       casam pelo nome: lírios rosa e lírios brancos com boca-de-leão R$ 360, mix
       de flores R$ 250, rosas no cilindro R$ 220, box de girassol R$ 220. O
       GIRASSOL NO VIDRO É O PALPITE: o Wix tem "Buquê de Girassol em vaso de
       vidro" (R$ 270, 10 girassóis) e "Arranjo de Girassol em vaso de vidro"
       (R$ 200, 5 hastes em vaso QUADRADO). A foto do cliente tem vaso ampulheta e
       gola de folhas, que é o primeiro — entrou a 270.

       O BOX DE GIRASSOL NÃO É VIDRO, e a categoria se chama "Arranjos em vidro".
       Entrou em `arranjos` porque é arranjo montado que fica em pé na mesa; se a
       casa quiser, o nome da categoria é uma linha no CATEGORIAS. */
    { id: 'p37', nome: 'Arranjo lírios rosa e boca-de-leão', cat: 'arranjos',
      flor: 'lírio', permanencia: 'flor de corte', preco: 360,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-rosa-boca-de-leao-estudio-4x5.jpg?v=111851324554249217581790260662',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-rosa-boca-de-leao-detalhe-4x5.jpg?v=29002141396457886721790262704',
      resumo: 'Lírio rosa e boca-de-leão, no vaso de vidro.' },

    { id: 'p38', nome: 'Arranjo mix de flores', cat: 'arranjos',
      flor: 'mix de flores', permanencia: 'flor de corte', preco: 250,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mix-de-flores-estudio-4x5.jpg?v=33245598198025211791790260660',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mix-de-flores-detalhe-4x5.jpg?v=99083934313185050091790601275',
      resumo: 'Girassol, orquídea e alstroeméria num vaso baixo.' },

    { id: 'p39', nome: 'Arranjo lírios brancos e boca-de-leão', cat: 'arranjos',
      flor: 'lírio', permanencia: 'flor de corte', preco: 360,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-brancos-boca-de-leao-estudio-4x5.jpg?v=37080983614929444611790260660',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-brancos-boca-de-leao-detalhe-4x5.jpg?v=101474017088486417271790262704',
      resumo: 'Lírio branco, boca-de-leão e alstroeméria no vidro.' },

    { id: 'p40', nome: 'Arranjo de rosas no cilindro', cat: 'arranjos',
      flor: 'rosa', permanencia: 'flor de corte', preco: 220,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-rosas-no-cilindro-estudio-4x5.jpg?v=110470713324271413481790260660',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-rosas-no-cilindro-detalhe-4x5.jpg?v=21253050233995717541790262704',
      resumo: 'Rosas vermelhas no cilindro de vidro, com laço.' },

    { id: 'p41', nome: 'Arranjo de girassol no vidro', cat: 'arranjos',
      flor: 'girassol', permanencia: 'flor de corte', preco: 270,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-girassol-no-vidro-estudio-4x5.jpg?v=160698985824298053861790260662',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-girassol-no-vidro-detalhe-4x5.jpg?v=63443102088416592151790262704',
      resumo: 'Girassóis com gola de folhas, no vaso de vidro.' },

    { id: 'p42', nome: 'Box de girassol', cat: 'arranjos',
      flor: 'girassol', permanencia: 'flor de corte', preco: 220,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-box-de-girassol-estudio-4x5.jpg?v=105973682542783490381790260662',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-box-de-girassol-detalhe-4x5.jpg?v=103873607472057770281790262704',
      resumo: 'Girassóis numa caixa redonda, com laço de fita.' },

    /* ------------------------------------------------ A FAMÍLIA BUQUÊS (24/09/2026)
       Os sete buquês da pasta do cliente no Drive, fotografados no mesmo estúdio
       claro das orquídeas e dos arranjos, com a mão da florista segurando pelo
       gargalo (mão = régua de escala, §17 do doc 30). Com eles a categoria `buques`
       deixa de ser `aCaminho`.

       PREÇO, tirado do doc 10 (site atual no Wix) e A CONFIRMAR com a casa. Cinco
       casam pelo nome: 36 rosas colombianas R$ 1.000, girassol 20 hastes R$ 480,
       mix da estação R$ 300, mix clássico R$ 300 (slug `lírios-e-girassol`, que é a
       foto) e mix flores do campo R$ 250. DOIS NÃO CASAM e entram SOB CONSULTA
       (`preco: null`), em vez de palpite: a rosa colombiana pode ser a de 12, 15 ou
       24 hastes no Wix (R$ 350, 380, 700) e o mix de flores pode ser o I ou o III
       (R$ 240, 300). Quando o número vier: preço na peça + produto na Shopify. */
    { id: 'p43', nome: 'Buquê rosa colombiana', cat: 'buques',
      flor: 'rosa', permanencia: 'flor de corte', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-rosa-colombiana-estudio-4x5.jpg?v=105191174949309723261791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-rosa-colombiana-detalhe-4x5.jpg?v=79377650035726604221790607825',
      resumo: 'Rosas colombianas vermelhas numa gola de juta, com ráfia.' },

    { id: 'p44', nome: 'Buquê 36 rosas colombianas', cat: 'buques',
      flor: 'rosa', permanencia: 'flor de corte', preco: 1000,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-36-rosas-colombianas-estudio-4x5.jpg?v=104042842079475572121791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-36-rosas-colombianas-detalhe-4x5.jpg?v=92968545351790532791790607826',
      resumo: 'Trinta e seis rosas colombianas, tela branca e laço de cetim.' },

    { id: 'p45', nome: 'Buquê 20 girassóis', cat: 'buques',
      flor: 'girassol', permanencia: 'flor de corte', preco: 480,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-20-girassois-estudio-4x5.jpg?v=68750230692938913551791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-20-girassois-detalhe-4x5.jpg?v=88627863303095475601790607825',
      resumo: 'Vinte girassóis com solidago, na juta amarrada com ráfia.' },

    { id: 'p46', nome: 'Buquê mix da estação', cat: 'buques',
      flor: 'mix de flores', permanencia: 'flor de corte', preco: 300,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-da-estacao-estudio-4x5.jpg?v=45771197232324770181791298208',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-da-estacao-detalhe-4x5.jpg?v=104920056470363599491790607826',
      resumo: 'Gérbera, alstroeméria e crisântemo numa gola de juta.' },

    { id: 'p47', nome: 'Buquê mix de flores clássico', cat: 'buques',
      flor: 'mix de flores', permanencia: 'flor de corte', preco: 300,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-classico-estudio-4x5.jpg?v=93869759753511507291791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-classico-detalhe-4x5.jpg?v=71766740509638924381790607655',
      resumo: 'Lírio laranja, girassol, gérbera e rosa no papel kraft.' },

    { id: 'p48', nome: 'Buquê mix de flores do campo', cat: 'buques',
      flor: 'mix de flores', permanencia: 'flor de corte', preco: 250,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-do-campo-estudio-4x5.jpg?v=93070172400053986301791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-do-campo-detalhe-4x5.jpg?v=1705066858299585391790607655',
      resumo: 'Flores miúdas do campo, papel rosado e tela creme com laço.' },

    { id: 'p49', nome: 'Buquê mix de flores', cat: 'buques',
      flor: 'mix de flores', permanencia: 'flor de corte', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-estudio-4x5.jpg?v=35514049005691472341791295403',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-detalhe-4x5.jpg?v=175223743466670844001790607655',
      resumo: 'Lírio amarelo, gérbera e crisântemo na juta com ráfia.' },

    /* ---------------------------------------------- A FAMÍLIA PLANTAS (23/09/2026)
       As plantas de chão da pasta do cliente no Drive, uma foto cada, na mesma sala,
       câmera e luz da árvore da felicidade (fotos-produto/README.md). Categoria
       própria, `plantas-de-chao` (o id `plantas` é rota aposentada das orquídeas). Entraram SEM
       preço, a pedido do Erik: `preco: null` = sob consulta (ver `soConsulta`). */
    { id: 'p16', nome: 'Árvore da felicidade', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arvore-da-felicidade-estudio-4x5.jpg?v=145490714639440575311790186244',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arvore-da-felicidade-detalhe-4x5.jpg?v=168190466350853198741790191950',
      resumo: "Coluna densa de folha rendada. Planta de chão para canto claro." },
    { id: 'p17', nome: 'Comigo-ninguém-pode', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-comigo-ninguem-pode-estudio-4x5.jpg?v=31152417905264715291790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-comigo-ninguem-pode-detalhe-4x5.jpg?v=52435097995125522801790191950',
      resumo: "Folha larga manchada de creme. Aguenta meia-sombra." },
    { id: 'p18', nome: 'Dracena arbórea', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-arborea-estudio-4x5.jpg?v=19921572023269406871790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-arborea-detalhe-4x5.jpg?v=48209565096622144951790191949',
      resumo: "Um tronco só e uma copa de folhas longas. Porte de árvore pequena." },
    { id: 'p19', nome: 'Dracena compacta', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-compacta-estudio-4x5.jpg?v=15316152285247163441790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-compacta-detalhe-4x5.jpg?v=60349138659875127691790191949',
      resumo: "Folha curta, brilhante e fechada em tufos. Pede pouca luz." },
    { id: 'p20', nome: 'Dracena poá', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-poa-estudio-4x5.jpg?v=97012012969346927141790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-poa-detalhe-4x5.jpg?v=103030938075086844391790191949',
      resumo: "Tufos de folha verde-limão em várias alturas." },
    { id: 'p21', nome: 'Espada de São Jorge bicolor', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-espada-de-sao-jorge-bicolor-estudio-4x5.jpg?v=169202862189014592601790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-espada-de-sao-jorge-bicolor-detalhe-4x5.jpg?v=183979367922410696851790191949',
      resumo: "Folha em espada com borda amarela. Quase não pede água." },
    { id: 'p22', nome: 'Ficus lyrata bambino', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-bambino-estudio-4x5.jpg?v=17421267304622172701790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-bambino-detalhe-4x5.jpg?v=120862740116808171901790191949',
      resumo: "A lyrata de folha pequena, em coluna estreita." },
    { id: 'p23', nome: 'Ficus lyrata', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-estudio-4x5.jpg?v=7322068323825167951790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-detalhe-4x5.jpg?v=17162642646188176171790191949',
      resumo: "Folha grande em forma de violino. Gosta de luz forte e indireta." },
    { id: 'p24', nome: 'Ficus elastica', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-elastica-estudio-4x5.jpg?v=44616862446759364891790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-elastica-detalhe-4x5.jpg?v=128352025865390423201790191949',
      resumo: "Folha grossa, quase vinho. Brilho de couro." },
    { id: 'p25', nome: 'Filodendro baixo', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-baixo-estudio-4x5.jpg?v=143750005380578208681790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-baixo-detalhe-4x5.jpg?v=140880020616628556471790191950',
      resumo: "Roseta larga de folha brilhante. Porte baixo." },
    { id: 'p26', nome: 'Filodendro', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-estudio-4x5.jpg?v=30753690879367695341790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-detalhe-4x5.jpg?v=156201690582661889611790191950',
      resumo: "Folha em coração, conduzida em tutor. Cresce para cima." },
    { id: 'p27', nome: 'Lança de São Jorge', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-lanca-de-sao-jorge-estudio-4x5.jpg?v=140671779283091427961790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-lanca-de-sao-jorge-detalhe-4x5.jpg?v=70096467843890614871790191950',
      resumo: "Feixe de folhas cilíndricas e retas. Quase não pede água." },
    { id: 'p28', nome: 'Pacová', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pacova-estudio-4x5.jpg?v=29367194092988569791790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pacova-detalhe-4x5.jpg?v=111637243499214999131790191950',
      resumo: "Folha grande e brilhante sobre talo grosso." },
    { id: 'p29', nome: 'Palmeira arbórea', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-arborea-estudio-4x5.jpg?v=112899343987616532831790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-arborea-detalhe-4x5.jpg?v=121977528076386383061790191950',
      resumo: "Folhas longas e estreitas em fonte, cheia desde a base." },
    { id: 'p30', nome: 'Palmeira ráfia', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-rafia-estudio-4x5.jpg?v=173601455724939797731790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-rafia-detalhe-4x5.jpg?v=126076226602108442121790191950',
      resumo: "Leques de folha fina sobre hastes de fibra. Aceita meia-sombra." },
    { id: 'p31', nome: 'Pata de elefante', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pata-de-elefante-estudio-4x5.jpg?v=181107848832483308541790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pata-de-elefante-detalhe-4x5.jpg?v=102440981204250394691790191950',
      resumo: "Base bojuda e folhas finas caindo como cabelo." },
    { id: 'p32', nome: "Pau d'água", cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pau-dagua-estudio-4x5.jpg?v=167640754171805164561790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pau-dagua-detalhe-4x5.jpg?v=67370301920479779611790191949',
      resumo: "Troncos de alturas diferentes com tufos de folha listrada." },
    { id: 'p33', nome: 'Pleomele variegata', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-variegata-estudio-4x5.jpg?v=92909646148156668641790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-variegata-detalhe-4x5.jpg?v=21522299255132075631790191949',
      resumo: "Folha curta listrada de amarelo, em arbusto alto." },
    { id: 'p34', nome: 'Pleomele verde', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-verde-estudio-4x5.jpg?v=86307892479553548841790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-verde-detalhe-4x5.jpg?v=154052488222488627881790191949',
      resumo: "Coluna densa de folha estreita e brilhante." },
    { id: 'p35', nome: 'Yucca', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-yucca-estudio-4x5.jpg?v=41013661274004544141790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-yucca-detalhe-4x5.jpg?v=60703644708951556551790191949',
      resumo: "Dois troncos com rosetas de folha em espada." },
    { id: 'p36', nome: 'Zamioculca', cat: 'plantas-de-chao',
      permanencia: 'planta viva', preco: null,
      img: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-zamioculca-estudio-4x5.jpg?v=106322583743210441411790186243',
      img2: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-zamioculca-detalhe-4x5.jpg?v=147544210915049373261790191949',
      resumo: "Folha lustrosa, quase sem pedir água. Vai bem longe da janela." }
  ];

  /* Os ícones da faixa. Traço 1,5 em caixa de 20, ponta e junta redondas — o
     mesmo desenho dos ícones do cabeçalho, para a faixa não parecer um jogo
     comprado de fora.

     Não são quatro desenhos intercambiáveis. Flor de corte e planta em vaso
     são o eixo `permanencia` do catálogo (01 §3.3) desenhado: o que chega hoje
     contra o que fica. Por isso a primeira tem haste e a terceira tem vaso, e
     a diferença entre as duas está na silhueta, que é o que sobra a 17px. */
  var ICONES = {
    /* flor de corte: quatro pétalas, haste e uma folha */
    flor: '<circle cx="10" cy="3.4" r="1.9"/><circle cx="13.1" cy="6.5" r="1.9"/>' +
          '<circle cx="10" cy="9.6" r="1.9"/><circle cx="6.9" cy="6.5" r="1.9"/>' +
          '<path d="M10 11.6V18"/>' +
          '<path d="M10 15.4c-2 0-3.6-1.4-3.6-3.2 2 0 3.6 1.4 3.6 3.2Z"/>',
    /* a entrega: furgão */
    entrega: '<path d="M1.6 14.2V5.8h9.6v8.4"/><path d="M11.2 8.6h3.4l3.8 3.4v2.2h-1.4"/>' +
             '<path d="M7.2 14.2h4.4"/>' +
             '<circle cx="5" cy="14.6" r="1.7"/><circle cx="14.4" cy="14.6" r="1.7"/>',
    /* planta viva: vaso, caule e duas folhas */
    planta: '<path d="M5.6 12.4h8.8l-1 5.2H6.6l-1-5.2Z"/><path d="M10 12.4V7"/>' +
            '<path d="M10 9.6c-2.1 0-3.8-1.5-3.8-3.4 2.1 0 3.8 1.5 3.8 3.4Z"/>' +
            '<path d="M10 8.2c0-2 1.6-3.6 3.6-3.6 0 2-1.6 3.6-3.6 3.6Z"/>',
    /* a visita que se repete: a seta que dá a volta */
    volta: '<path d="M17 10a7 7 0 1 1-7-7c1.96 0 3.84.82 5.19 2.26"/>' +
           '<path d="M17 2.6v4.7h-4.7"/>'
  };

  /* Uma redação só. A faixa corria a redação longa no celular e parava com a
     curta no computador porque as quatro frases longas somam ~1435px de
     caixa-alta com entreletra contra 1104px de área útil do container, e em
     fila estática transbordavam. Virando esteira em toda largura, a restrição
     que criou a segunda redação deixou de existir. */
  var GARANTIAS = [
    { ico: 'flor',    t: 'Montado no dia, com a flor da estação' },
    { ico: 'entrega', t: 'Entrega em dia útil' },
    /* Era "Também faz jardim e planta para escritório". Caiu por dois motivos:
       "Também faz" é hesitação — abre a entrada pedindo licença, e as outras
       três são rótulos secos —, e a frase media 42 caracteres de caixa-alta
       com entreletra, a mais larga da faixa depois do combinado. O rótulo só
       precisa nomear a segunda frente; quem ela é já está no ícone do vaso, e
       a visita que se repete é a entrada seguinte. */
    { ico: 'planta',  t: 'Jardim e planta de escritório' },
    { ico: 'volta',   t: 'Combinado de manutenção: a gente volta toda semana' }
  ];


  /* ---------------------------------------------------------- avaliações
     TUDO AQUI É REAL E CONFERIDO. Ficha do Google CID 16704393964368233123 —
     a mesma que o site atual já linka no rodapé —, lida no navegador em
     13/08/2026. Procedência, conferência de homonímia e o que ficou de fora
     estão em 50-avaliacoes-pesquisa.md.

     TRÊS REGRAS QUE NÃO SE MEXEM:
     1. Texto LITERAL. Nada de corrigir grafia, pontuação ou repetição de "!".
        Se precisar cortar, não usa.
     2. A nota geral e a contagem andam JUNTAS. "4,6" sozinho esconde a amostra.
     3. O link vai para as 90, não para estas seis. A casa tem uma avaliação de
        1 estrela, e quem quiser vê-la chega em um clique. É o que separa prova
        social de propaganda.
        QUEM CUMPRE ISSO HOJE É O SELO DA NOTA, que é um `<a>` inteiro para a
        ficha. A linha de procedência tinha um segundo link para o mesmo destino
        e ele saiu em 14/08/2026 — a regra é "existe uma saída para as 90 na
        seção", não "existem duas". */
  var AVALIACOES_GOOGLE = {
    nota: '4,6',
    quantidade: 90,
    /* Distribuição lida do histograma da própria ficha. A soma bate com o
       total, o que é a conferência de que a leitura não perdeu faixa nenhuma.
       Publicamos "73 de cinco estrelas" porque é o número que qualifica a
       média: 4,6 pode ser muita nota média ou muita nota alta com alguma baixa,
       e são coisas diferentes. */
    cincoEstrelas: 73,
    fonte: 'https://maps.google.com/?cid=16704393964368233123',
    /* A data do Google é relativa ("2 meses atrás"). O site publica a conversão
       a partir de 13/08/2026 e diz que ela é aproximada — porque é. */
    lidoEm: '13 de agosto de 2026'
  };

  /* TRÊS, e não seis. A escolha não é pelas mais elogiosas — é pelas que PROVAM
     coisas diferentes. Seis depoimentos elogiando atendimento viram parede de
     texto e o leitor pula a seção inteira; três que respondem três objeções
     distintas fazem o trabalho.

       · Raphael Ribeiro  — o pedido inteiro à distância funciona (WhatsApp,
         pix, entrega com cartão). É a jornada que o e-commerce precisa provar.
       · Marianna Maldonado — a segunda frente de receita existe e funciona.
         É a ÚNICA prova pública de paisagismo corporativo que a casa tem.
       · Ana Cristina Dias de Moura — "o preço é justo", que responde de frente
         o "não somos a flor mais barata" do manual. Local Guide com 46
         avaliações, o que pesa mais que um perfil de uma avaliação só.

     Ficaram de fora, e estão em 50-avaliacoes-pesquisa.md com o motivo:
     Mayara Takano, Lien Lien, Adriana Anselmo e Mariana Ayako. Todas reais,
     todas 5 estrelas, todas conferidas — só redundantes entre si. */
  var AVALIACOES = [
    { autor: 'Raphael Ribeiro', quando: 'janeiro de 2026', relativo: '7 meses atrás',
      texto: 'Gostaria de deixar aqui minha satisfação pelo atendimento, já realizei o pedido e pela terceira vez me surpreendi, sempre muito atento , isso de longe , só pelo WhatsApp , fiz o pix e entregaram com cartão e tudo conforme solicitado, recomendo muito , são muito caprichosos .' },

    /* Estava truncada com "… Mais" na primeira leitura e quase ficou de fora;
       foi recuperada inteira na conferência.
       O "por" da primeira linha é da autora, não erro de transcrição. */
    { autor: 'Marianna Maldonado', quando: '2025', relativo: 'um ano atrás',
      texto: 'Minha experiência por maravilhosa.\nEu estava buscando um serviço de paisagismo pra minha empresa, localizada na grande São Paulo, e eu fui super bem atendida pelo Giovanni.\nAconselho de olhos fechados! Preço, prazo e sem contar no bom atendimento!! Podem confiar!' },

    /* O NOME ESTÁ CAPITALIZADO E O PERFIL DO GOOGLE NÃO ESTÁ. Lá ele aparece
       "ana cristina dias de moura", tudo minúsculo, e foi assim que entrou na
       transcrição. A regra de "palavra por palavra, sem corrigir grafia"
       (50-avaliacoes-pesquisa.md §2) governa o TEXTO da avaliação — que continua
       intocado, inclusive nos erros das outras duas. A assinatura é atribuição,
       não citação: numa fila de três, dois nomes capitalizados e um em caixa
       baixa lê como defeito de renderização do site, não como escolha de quem
       escreveu. A grafia da origem fica registrada no doc para quem conferir. */
    { autor: 'Ana Cristina Dias de Moura', quando: 'janeiro de 2026', relativo: '7 meses atrás',
      guia: 'Local Guide',
      texto: 'Foi uma excelente experiência! Eles estão preparados para entendimento rápido e de qualidade. O produto é lindo e o preço é justo. Parabéns! Sucesso para o negócio.' }
  ];


  /* ------------------------------------------------------------- clientes
     A ESTEIRA DE EMPRESAS NASCE VAZIA, E ISSO É PROPOSITAL.

     Exibir a marca de uma empresa numa seção chamada "quem pede aqui" é
     afirmar publicamente que ela é cliente. Se não for, o problema é do
     Gilberto, não nosso: é uso indevido de marca de terceiro. Então esta lista
     só se preenche com nome que veio DA CASA, e cada logo entra com a origem
     do arquivo registrada em img/clientes/FONTES.md — o mesmo rigor que as
     avaliações receberam.

     Enquanto a lista estiver vazia, a seção fica escondida e o site sobe sem
     ela. Nada de logo de exemplo, nem de "empresa fictícia": um mural de
     clientes falso é a coisa mais fácil de checar e a mais cara de explicar.

     PARA PREENCHER: um objeto por empresa, na ordem em que devem aparecer.
       { nome: 'Nome como a empresa assina',
         arq:  'slug-do-arquivo',      // //casaflores.com.br/cdn/shop/t/2/assets/casaflores-clientes__original__<slug>.png
         alt:  'Nome por extenso' }    // o que o leitor de tela anuncia
  */
  /* As oito vieram do Erik em 13/08/2026. Cada arquivo foi puxado do site
     OFICIAL da própria empresa, e a URL de origem de cada um está registrada em
     img/clientes/FONTES.md — logo sem procedência não sobe.

     `w` e `h` são a medida EM TELA, calculada por área ótica pelo
     processa_logos.py, e não um número escolhido no olho. É por isso que o
     escudo da Porsche tem 34x46 e o logotipo da Kimberly-Clark tem 150x18: as
     duas marcas ocupam a mesma mancha de tinta, que é o que o olho compara.
     Igualar por ALTURA faria o escudo parecer o dobro do tamanho da fita.
     O arquivo no disco tem o triplo disso, para retina.

     A ordem alterna comprida e compacta de propósito: duas fitas longas
     seguidas fazem a esteira parecer uma frase, não um mural. */
  /* VÍDEOS DA HOME (seção antes das categorias, 28/09/2026).
     Cada vídeo: { titulo, arq, poster }.
       titulo — a legenda embaixo do cartão, curta (cabe em uma linha a 18px);
       arq    — 'img/videos/<nome>.mp4', vertical 9:16, sem som obrigatório;
       poster — 'img/videos/<nome>.jpg', o primeiro quadro, 9:16.
     Vídeo sem `arq` não entra. Sem nenhum com `arq`, a seção inteira fica
     escondida — nada de caixa vazia no ar.
     O vídeo nasce SEM `src` (preload none): quem põe o arquivo é o clique, então
     a home não baixa megabytes de vídeo para quem só está passando.

     VIDEOS_PREVIA só aparece com ?videos=previa na URL: são as fotos da casa no
     lugar dos vídeos, para ver o desenho antes de o material chegar. */
  var VIDEOS = [
    /* 1º vídeo, 28/09/2026 (lv_0_20260618120153.mp4 do Erik): a florista escolhe
       as flores na estante, monta, embrulha em papel e tela, e mostra o buquê
       pronto. 1080x1920 -> 720x1280, 2 passadas a 1,4 Mbit/s, 4,3 MB (era 33,6).
       O áudio original era silêncio (-91 dB) e saiu. Capa = quadro de 21 s. */
    /* MÚSICA DE FUNDO, 28/09/2026 — uma trilha DIFERENTE por vídeo (pedido do
       Erik: "não quero a mesma música para todos"), todas instrumentais geradas
       no Magnific/Lyria, a -20 LUFS, entrada 0,5 s e saída 1,2 s. Arquivos em
       videos-drive/: buquê = violao.wav · estante = estante-alegre.wav · arranjo =
       bossa.mp3 · orquídeas = orquideas-alegre.wav · empresa = lounge.wav.
       som: true mostra o botão de som. */
    { titulo: 'Montando o buquê', arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__montando-o-buque.mp4?v=139011944291276044111790619941', poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__montando-o-buque.jpg?v=108152975333508606811790613712', som: true },
    /* 2º a 6º, 28/09/2026 — escolhidos pela auditoria da pasta do Drive
       (videos-drive/AUDITORIA-VIDEOS.md): firmes, sem logo de terceiro, mão
       feminina. Mesma receita do 1º: 720x1280, 30 fps, 2 passadas a 1,4 Mbit/s,
       sem áudio, faststart.
       · estante  = VID_20260923_154411 (vitrine da loja, 6 s)
       · arranjo  = VID_20260622_164745 + _164752 emendados (florista de uniforme, 14 s)
       · orquídeas= VID_20260923_154424 (7 s)
       · empresa  = VID_20260914_144422 (hall corporativo, câmera parada, 13,5 s)
       · entrega  = VID_20251219_152740, só 0,7–6,7 s (o resto treme) */
    { titulo: 'Na estante da casa',    arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__na-estante-da-casa.mp4?v=38305308541334181281790620951',    poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__na-estante-da-casa.jpg?v=142337279981302697891790615829',    som: true },
    { titulo: 'Fechando o arranjo',    arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__fechando-o-arranjo.mp4?v=123333797823087153521790619941',    poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__fechando-o-arranjo.jpg?v=8699492020972725291790615829',    som: true },
    { titulo: 'As orquídeas da casa',  arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__as-orquideas-da-casa.mp4?v=74711947415843367501790620951',  poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__as-orquideas-da-casa.jpg?v=14888268961988054241790615829',  som: true },
    { titulo: 'Arranjo para empresa',  arq: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__arranjo-para-empresa.mp4?v=3719943014643436141790619942',  poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-videos__arranjo-para-empresa.jpg?v=103737219835902780091790615829',  som: true }
    /* 'Pronto para a entrega' (VID_20251219_152740) saiu em 28/09/2026 a pedido do
       Erik. Arquivos ficam em img/videos/ caso volte. */
  ];
  var VIDEOS_PREVIA = [
    { titulo: 'Na Casa Flores',        poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-rosa-colombiana-estudio-4x5.jpg?v=105191174949309723261791295403' },
    { titulo: 'A escolha das flores',  poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mix-de-flores-estudio-4x5.jpg?v=33245598198025211791790260660' },
    { titulo: 'Montando o buquê',      poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-20-girassois-estudio-4x5.jpg?v=68750230692938913551791295403' },
    { titulo: 'As orquídeas da casa',  poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-branca-estudio-4x5.jpg?v=38156580603593769751789578146' },
    { titulo: 'Pronto para a entrega', poster: '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-da-estacao-estudio-4x5.jpg?v=45771197232324770181791298208' }
  ];

  var CLIENTES = [
    /* The official Porsche Design System uses the wordmark as the main identifier. */
    { nome: 'Porsche',          arq: 'porsche-branca', ext: 'svg', classe: 'cliente--porsche', w: 170, h: 28 },
    { nome: 'Pullman',          arq: 'pullman',        w: 118, h: 23 },
    { nome: 'Kimberly-Clark',   arq: 'kimberly-clark', w: 150, h: 18 },
    { nome: 'Blue Tree Hotels', arq: 'blue-tree',      w:  94, h: 29 },
    { nome: 'Fogo de Chão',     arq: 'fogo-de-chao',   w: 142, h: 19 },
    { nome: 'Banco ABC Brasil', arq: 'banco-abc',      w:  47, h: 46 },
    { nome: 'Cheil',            arq: 'cheil',          w:  94, h: 29 },
    /* As duas MARCAS DE BLOCO da lista, e por isso as duas maiores em altura.
       O campo chapado não é tinta da marca, é fundo — e a régua de área o conta
       como se fosse. Igualando área, o retângulo do Travelex ficava do tamanho
       do logotipo da Cheil e as letras dentro dele saíam com 4px, ilegíveis.
       Nelas o que o olho compara é o TIPO, não o campo, então vão ao teto de
       altura (46px). O Banco ABC já batia nesse teto sozinho, pela proporção. */
    { nome: 'Travelex Bank',    arq: 'travelex-branca-v7', w: 159, h: 46, v: '20260904-5' }
  ];

  /* ------------------------------------------------------------- utilitários */

  /* AS FOTOS AINDA NÃO SÃO DAS PEÇAS.
     A produção fotográfica não aconteceu, e o catálogo do site atual tem foto
     de vitrine — que é o oposto do que o manual pede. Enquanto isso, cada peça
     aponta para uma imagem de processo da casa.

     Isso não pode ficar implícito: nome + preço + foto lado a lado leem como a
     oferta, e prometer uma peça e mandar outra é reclamação certa. Por isso o
     `alt` descreve A FOTO, não a peça, e a grade carrega um aviso visível. */
  var FOTO_ALT = {
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-rosa-colombiana-detalhe-4x5.jpg?v=79377650035726604221790607825': "O buquê rosa colombiana de perto: rosas colombianas vermelhas de pétalas pontudas viradas para fora, com folhas de ruscus, na juta.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-36-rosas-colombianas-detalhe-4x5.jpg?v=92968545351790532791790607826': "O buquê de 36 rosas colombianas de perto: rosas vermelhas abertas entre raminhos de solidago amarelo, no celofane e na tela branca.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-20-girassois-detalhe-4x5.jpg?v=88627863303095475601790607825': "O buquê de 20 girassóis de perto: girassóis de miolo marrom entre solidago e folhas verdes, na juta.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-da-estacao-detalhe-4x5.jpg?v=104920056470363599491790607826': "O buquê mix da estação de perto: gérberas rosa e amarelas, crisântemos roxos e brancos e alstroemérias, na juta.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-classico-detalhe-4x5.jpg?v=71766740509638924381790607655': "O buquê mix clássico de perto: o lírio laranja aberto no centro, botões de lírio, dois girassóis, gérberas rosa, rosas, alstroemérias brancas e bocas-de-leão, no papel kraft e translúcido.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-do-campo-detalhe-4x5.jpg?v=1705066858299585391790607655': "O buquê mix de flores do campo de perto: crisântemos amarelos e roxos, alstroemérias brancas e alaranjadas e frutinhas de hypericum, no papel rosado e na tela bege.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-detalhe-4x5.jpg?v=175223743466670844001790607655': "O buquê mix de flores de perto: lírios amarelos e botões, gérberas rosa, crisântemos roxos e amarelos e alstroemérias, na juta.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-rosa-boca-de-leao-detalhe-4x5.jpg?v=29002141396457886721790262704': "Detalhe do arranjo de lírios rosa: um lírio cor de salmão aberto de frente, com as pintinhas e as anteras cor de ferrugem, ao lado de uma espiga de boca-de-leão rosa e de um botão fechado, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mix-de-flores-detalhe-4x5.jpg?v=99083934313185050091790601275': "Detalhe do arranjo mix de flores, de perto: o girassol à esquerda, três orquídeas magenta no centro, alstroemérias vermelha e amarela, craspédia e hypericum, com a boca do vaso de vidro embaixo, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-brancos-boca-de-leao-detalhe-4x5.jpg?v=101474017088486417271790262704': "Detalhe do arranjo de lírios brancos: um lírio branco aberto com a garganta verde-limão, ao lado de uma espiga de boca-de-leão branca, um botão verde e uma alstroeméria branca de riscos vinho, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-rosas-no-cilindro-detalhe-4x5.jpg?v=21253050233995717541790262704': "Detalhe do arranjo de rosas: uma rosa vermelha aberta, de pétalas aveludadas, com um cacho de hypericum vermelho e folhas verde-acinzentadas, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-girassol-no-vidro-detalhe-4x5.jpg?v=63443102088416592151790262704': "Detalhe do arranjo de girassol: um girassol grande de frente, com o miolo marrom em espiral, entre solidago e folhas verdes, com outros girassóis atrás, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-box-de-girassol-detalhe-4x5.jpg?v=103873607472057770281790262704': "Detalhe do box de girassol: um girassol de frente diante de uma folha larga cor de vinho, com hypericum rosa e vermelho e solidago amarelo-esverdeado, contra a parede caiada clara.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-rosa-colombiana-estudio-4x5.jpg?v=105191174949309723261791295403': "O buquê de rosa colombiana da casa: um domo de rosas vermelhas abertas com ruscus, numa gola de juta dobrada e amarrada com ráfia, segurado pelo gargalo por uma mão sobre a bancada de pinus.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-36-rosas-colombianas-estudio-4x5.jpg?v=104042842079475572121791295403': "O buquê de 36 rosas colombianas da casa: rosas vermelhas de pétalas pontudas com solidago, em celofane e tela branca enrolada, laço de cetim vermelho e saco de água, segurado por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-20-girassois-estudio-4x5.jpg?v=68750230692938913551791295403': "O buquê de 20 girassóis da casa: girassóis com solidago numa gola larga de juta, amarrados com ráfia e com saco de água transparente, segurado pelo gargalo por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-da-estacao-estudio-4x5.jpg?v=45771197232324770181791298208': "O buquê mix da estação da casa: gérberas rosa e amarelas, crisântemos roxos, alstroemérias e solidago numa gola de juta com ráfia, a base em celofane transparente, segurado por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-classico-estudio-4x5.jpg?v=93869759753511507291791295403': "O buquê mix clássico da casa: lírio laranja, dois girassóis, gérberas, cravos e rosas cor-de-rosa com boca-de-leão, em folhas de papel kraft e filme fosco, segurado por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-do-campo-estudio-4x5.jpg?v=93070172400053986301791295403': "O buquê mix de flores do campo da casa: crisântemos amarelos e roxos, alstroemérias, hypericum e flores miúdas, em papel rosado e tela creme com laço de cetim champanhe, segurado por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-buque-mix-de-flores-estudio-4x5.jpg?v=35514049005691472341791295403': "O buquê mix de flores da casa: lírios amarelos com botões, gérberas, crisântemos roxos e amarelos e alstroemérias numa gola de juta com ráfia, segurado pelo gargalo por uma mão.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-rosa-boca-de-leao-estudio-4x5.jpg?v=111851324554249217581790260662': "O arranjo de lírios rosa da casa: cinco lírios cor de salmão abertos com botões e espigas de boca-de-leão rosa, num vaso de vidro verde em ampulheta, sobre a bancada de pinus cor de mel.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mix-de-flores-estudio-4x5.jpg?v=33245598198025211791790260660': "O arranjo mix de flores da casa: um girassol, orquídeas magenta, alstroemérias amarelas e uma vermelha, craspédia e hypericum, num vaso baixo de vidro transparente, sobre a bancada de pinus.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-lirios-brancos-boca-de-leao-estudio-4x5.jpg?v=37080983614929444611790260660': "O arranjo de lírios brancos da casa: lírios abertos e botões verdes, boca-de-leão e alstroemérias brancas, num vaso de vidro em ampulheta forrado por dentro com uma folha verde enrolada.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-rosas-no-cilindro-estudio-4x5.jpg?v=110470713324271413481790260660': "O arranjo de rosas da casa: quatro rosas vermelhas abertas com folhagem verde-acinzentada e hypericum, num cilindro baixo de vidro fumê amarrado com fita de cetim vermelha.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-girassol-no-vidro-estudio-4x5.jpg?v=160698985824298053861790260662': "O arranjo de girassol da casa: seis girassóis com solidago e uma gola larga de folhas verdes, num vaso de vidro de cintura fina amarrado com laço de cetim dourado.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-box-de-girassol-estudio-4x5.jpg?v=105973682542783490381790260662': "O box de girassol da casa: quatro girassóis subindo em diagonal entre folhas cor de vinho, solidago e hypericum, numa caixa redonda preta com laço de fita dourada listrada.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arvore-da-felicidade-estudio-4x5.jpg?v=145490714639440575311790186244': "A árvore da felicidade da casa: uma coluna alta e densa de folhas rendadas verde-claro, num vaso cilíndrico laranja-vermelhão sobre três pés, no piso de pinho da sala.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-comigo-ninguem-pode-estudio-4x5.jpg?v=31152417905264715291790186243': "A comigo-ninguém-pode da casa: touceira cheia de folhas largas verde-escuras salpicadas de creme, num vaso de terracota sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-arborea-estudio-4x5.jpg?v=19921572023269406871790186243': "A dracena arbórea da casa: tronco fino e reto coroado por um leque de folhas longas verde-escuras, num vaso alto off-white com seixos brancos.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-compacta-estudio-4x5.jpg?v=15316152285247163441790186243': "A dracena compacta da casa: hastes de alturas diferentes cobertas de tufos de folhas curtas e brilhantes, num vaso alto grafite.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-dracena-poa-estudio-4x5.jpg?v=97012012969346927141790186243': "A dracena poá da casa: tufos de folhas verde-limão empilhados em várias hastes, num vaso alto marrom de textura canelada.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-espada-de-sao-jorge-bicolor-estudio-4x5.jpg?v=169202862189014592601790186243': "A espada de São Jorge bicolor da casa: touceira de folhas eretas em espada, verdes com faixas acinzentadas e borda amarela, num vaso alto marrom-escuro com prato.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-bambino-estudio-4x5.jpg?v=17421267304622172701790186243': "O ficus lyrata bambino da casa: coluna estreita de folhas pequenas em forma de violino, num vaso marrom canelado sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-lyrata-estudio-4x5.jpg?v=7322068323825167951790186243': "O ficus lyrata da casa: folhas grandes e onduladas em forma de violino, num vaso preto brilhante sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-ficus-elastica-estudio-4x5.jpg?v=44616862446759364891790186243': "O ficus elastica da casa: folhas grossas e brilhantes verde-quase-vinho, num vaso branco alto com casca de pinus sobre a terra.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-baixo-estudio-4x5.jpg?v=143750005380578208681790186243': "O filodendro baixo da casa: roseta larga de folhas brilhantes verde-escuras, num vaso cônico bege sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-filodendro-estudio-4x5.jpg?v=30753690879367695341790186243': "O filodendro da casa: coluna de folhas em coração verde-claro rajadas de amarelo, conduzida em tutor, num vaso de terracota.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-lanca-de-sao-jorge-estudio-4x5.jpg?v=140671779283091427961790186243': "A lança de São Jorge da casa: feixe de folhas cilíndricas, retas e pontudas, num vaso alto preto fosco com casca de pinus.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pacova-estudio-4x5.jpg?v=29367194092988569791790186243': "A pacová da casa: roseta de folhas grandes e brilhantes sobre talos grossos verde-claros, num vaso branco bojudo com frisos.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-arborea-estudio-4x5.jpg?v=112899343987616532831790186243': "A palmeira arbórea da casa: tufo cheio de folhas longas e estreitas caindo em fonte, num vaso creme sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-palmeira-rafia-estudio-4x5.jpg?v=173601455724939797731790186243': "A palmeira ráfia da casa: hastes finas cobertas de fibra com leques de folhas estreitas em várias alturas, num vaso quadrado cinza-claro.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pata-de-elefante-estudio-4x5.jpg?v=181107848832483308541790186243': "A pata de elefante da casa: base bojuda e tronco fino coroado por uma cascata de folhas finas, num vaso alto preto brilhante.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pau-dagua-estudio-4x5.jpg?v=167640754171805164561790186243': "O pau d'água da casa: dois troncos de alturas diferentes com tufos de folhas largas de listra verde-limão, num vaso branco cilíndrico.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-variegata-estudio-4x5.jpg?v=92909646148156668641790186243': "A pleomele variegata da casa: arbusto alto de hastes ramificadas com folhas curtas de borda amarela, num vaso alto vermelho brilhante.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-pleomele-verde-estudio-4x5.jpg?v=86307892479553548841790186243': "A pleomele verde da casa: coluna alta e densa de folhas estreitas verde-escuras, num vaso alto cinza de textura de concreto.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-yucca-estudio-4x5.jpg?v=41013661274004544141790186243': "A yucca da casa: dois troncos de alturas diferentes, cada um com uma roseta de folhas em espada, num cachepô cúbico de mosaico espelhado.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-zamioculca-estudio-4x5.jpg?v=106322583743210441411790186243': "A zamioculca da casa: hastes eretas com folíolos lustrosos verde-escuros, num vaso branco brilhante sobre o piso de pinho.",
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-plantas-de-chao.jpg?v=63507425450560459471790605383': 'A árvore da felicidade da casa, alta e densa, no vaso laranja-vermelhão sobre fundo verde, com uma mão tocando a copa para dar a escala.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-proc-no-fita.jpg?v=137277332379067799631787835599': 'Foto de processo: as mãos apertam o nó da fita verde no cone de papel algodão, sobre a bancada da loja.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-hero-home-vertical.jpg?v=44308081015389066291787835599': 'Foto de processo: as mãos fecham a fita verde em volta do cone de papel com lisianthus e eucalipto.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-arranjos.jpg?v=141308180559873442891790605383': 'O arranjo de girassol da casa: cinco girassóis em alturas escalonadas, folha de salal na base e capim curvado, num vaso quadrado de vidro amarrado com ráfia, sobre a bancada de concreto claro, contra a parede caiada lisa, com a luz de dia vindo da direita e a sombra da peça desenhada na parede à esquerda.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-proc-corte-haste.jpg?v=93407047344639913731787835599': 'Foto de processo: a haste sendo cortada em diagonal sobre a borda do balde de zinco.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-plantas.jpg?v=14236603925174453821790605383': 'A orquídea phalaenopsis branca da casa: uma haste arqueada de flores brancas presa ao tutor, folhas grossas e a cuia de vidro cheia de casca de pinus, sobre a bancada de concreto claro, contra a parede caiada lisa, com a luz de dia vindo da esquerda e a sombra da haste arqueada desenhada na parede à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-cat-buques.jpg?v=45576225943230950741790605383': 'O buquê mix da estação da casa, segurado pela mão do florista: gérberas amarelas e rosa, alstroemérias e crisântemos numa gola de tela de juta amarrada com ráfia. O punho direito do florista fecha no gargalo do embrulho, logo abaixo do nó de ráfia, e carrega o buquê inteiro: as hastes cortadas ficam soltas no ar, um palmo acima da bancada de concreto claro, com a sombra delas na laje. O antebraço sai pela borda direita, contra a parede caiada lisa, sob a luz de dia vinda da esquerda.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-loja-bancada.jpg?v=94814491616030138951787835599': 'Foto da bancada da loja no meio de um serviço: papel meio desenrolado, carretel de fita e aparas de haste.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-loja-interior.jpg?v=85126268689183117321787835599': 'Foto do salão da loja: o balcão de trabalho no meio de um serviço, a mesa redonda com as orquídeas e o piso de concreto queimado.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-proc-dobra-papel.jpg?v=180722134369396009981787835599': 'Foto de processo: o papel algodão com o padrão de ramos sendo dobrado em cone sobre a bancada.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-magenta-estudio-4x5.jpg?v=31233368957226641071789578145': 'A orquídea magenta da casa: pétalas vinho-magenta aveludadas, de cor uniforme, com a coluna branca e o labelo de garganta amarela ao centro. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-branca-estudio-4x5.jpg?v=38156580603593769751789578146': 'A orquídea branca da casa: pétalas brancas lisas com o labelo amarelo sardento na garganta, e botões fechados verde-claros na ponta da haste. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-dalmata-estudio-4x5.jpg?v=174016111216004834971789578146': 'A orquídea dálmata da casa: pétalas brancas marcadas por manchas roxas grandes e redondas, espalhadas de forma irregular, com o labelo magenta-arroxeado. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-exotica-estudio-4x5.jpg?v=162500152317758862381789578146': 'A orquídea exótica da casa: pétalas fúcsia com uma borda branca larga e irregular contornando a aresta, e o labelo rosa de garganta escura. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-fucsia-estudio-4x5.jpg?v=34703993723956868631789578145': 'A orquídea fúcsia da casa: pétalas de fúcsia saturado com nervuras mais escuras abrindo em leque, coluna branca e labelo de crista amarela. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-gisele-estudio-4x5.jpg?v=47329509116921173081789578145': 'A orquídea gisele da casa: pétalas brancas salpicadas de pintas magenta finas e densas, com o labelo vermelho-vinho de garganta amarela. Uma haste presa a um tutor fino, com hastes de ruscus miúdo subindo ao lado e folhas largas e brilhantes abrindo da coroa, numa cuia de vidro redonda cheia de casca de pinus grossa até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás, e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-estudio-4x5.jpg?v=104542851631112063331790604536': 'O arranjo de mini orquídeas da casa: várias hastes arqueadas de mini phalaenopsis de pétala branca com rubor rosado e labelo magenta e amarelo, cada uma presa ao seu tutor fino, com folhas largas caindo sobre a borda de uma cuia de vidro larga e baixa cheia de casca de pinus com tufos de musgo verde, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, com a luz vindo da esquerda e por trás.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-magenta-detalhe-4x5.jpg?v=180984389867694006581790356448': 'Detalhe da orquídea magenta: duas flores abertas de pétala vinho-magenta aveludada, sem desenho, com a coluna branca ao centro e o labelo de garganta amarela, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-branca-detalhe-4x5.jpg?v=62328580317092244111790356448': 'Detalhe da orquídea branca: flor aberta de pétalas brancas lisas, com a nervura fina visível sob a superfície e o labelo amarelo-alaranjado sardento na garganta, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-dalmata-detalhe-4x5.jpg?v=39999288677807628891790356448': 'Detalhe da orquídea dálmata: pétalas brancas marcadas por manchas roxas grandes e redondas, espalhadas de forma irregular, com o labelo magenta-arroxeado ao centro, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-exotica-detalhe-4x5.jpg?v=49803675263918377781790356448': 'Detalhe da orquídea exótica: pétalas vinho-bordô com uma borda branca larga e irregular contornando a aresta em línguas desiguais, e o labelo rosa de garganta escura, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-fucsia-detalhe-4x5.jpg?v=114937264819836074851790356448': 'Detalhe da orquídea fúcsia: pétalas de fúcsia saturado com nervuras mais escuras abrindo em leque da base, coluna branca e labelo de crista amarela, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-orquidea-gisele-detalhe-4x5.jpg?v=97541082103965475031790356448': 'Detalhe da orquídea gisele: pétalas brancas salpicadas de centenas de pintas magenta finas, mais densas no centro e ralas na borda, com o labelo vermelho-vinho de garganta amarela, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-detalhe-4x5.jpg?v=163572010771330984881790603238': 'Detalhe do arranjo de mini orquídeas: flores pequenas de pétala branca com rubor rosado em direção ao centro e labelo magenta e amarelo, em hastes arqueadas que cruzam o quadro, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-lilas-detalhe-4x5.jpg?v=138598880039224908671789570311': 'Detalhe da mini orquídea lilás: três flores abertas de pétala lilás-rosa riscada de nervura magenta, com o labelo amarelo salpicado de vermelho ao centro, botões fechados à esquerda e folhas largas e brilhantes embaixo, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-gisele-detalhe-4x5.jpg?v=43512873934443842061789570311': 'Detalhe da mini orquídea gisele: pétalas brancas marcadas por blocos irregulares de vinho-bordô, labelo amarelo, botões verdes nas pontas das hastes e folhas largas embaixo, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-amarela-detalhe-4x5.jpg?v=150928348148451853601789570311': 'Detalhe da mini orquídea amarela: pétalas amarelas riscadas de nervura vermelha, labelo magenta ao centro, botões verdes ao longo da haste e folhas largas embaixo, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-phala-detalhe-4x5.jpg?v=54169532118470999221789570310': 'Detalhe do arranjo de mini orquídeas phalaenopsis: pétalas brancas com o labelo magenta forte, botões verdes nas hastes ramificadas e folhas embaixo, contra a parede caiada clara.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-lilas-estudio-4x5.jpg?v=92727125462459899801789571951': 'A mini orquídea lilás da casa: duas hastes escuras arqueadas, presas a tutores por clipes pretos, com flores lilás-rosa de nervura magenta e labelo amarelo salpicado, e botões fechados nas pontas. As folhas largas e brilhantes abrem da coroa sobre uma cuia de vidro redonda cheia de casca de pinus até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada cinza-clara, com a luz vindo da esquerda e a sombra da peça caindo na madeira à direita.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-gisele-estudio-4x5.jpg?v=151984021247575861181789570325': 'A mini orquídea gisele da casa: duas hastes escuras e retas, presas a tutores por clipes pretos, com uma dezena de flores brancas marcadas por manchas irregulares vinho-borgonha e lábio creme e amarelo, e dois botões nas pontas. As folhas lanceoladas e brilhantes sobem pelas hastes e abrem em leque sobre uma cuia de vidro redonda cheia de casca de pinus até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, sob luz de estúdio limpa vinda da esquerda.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-mini-orquidea-amarela-estudio-4x5.jpg?v=39045961656627542591789571395': 'A mini orquídea amarela da casa: duas hastes finas presas a tutores por clipes pretos, com seis flores amarelo-manteiga pálido riscadas por linhas finas vermelho-acastanhadas do centro até a borda, cada uma com um lábio magenta pequeno no meio, e uma ramificação baixa à esquerda carregando uma dúzia de botões verdes fechados. As folhas largas e brilhantes abrem num leque baixo sobre uma cuia de vidro redonda cheia de casca de pinus até a boca, apoiada na bancada de pinus cor de mel, contra a parede caiada clara, sob luz de estúdio limpa vinda da esquerda.',
    '//casaflores.com.br/cdn/shop/t/2/assets/casaflores-peca-arranjo-mini-orquideas-phala-estudio-4x5.jpg?v=122005584202016480361789575482': 'O arranjo de mini orquídeas phalaenopsis da casa: quatro plantas montadas juntas num cilindro baixo de vidro, com quatro hastes escuras arqueadas abrindo em leque e cerca de trinta flores brancas de lábio magenta e garganta amarela, cachos de botões verdes nas pontas, ramos de ruscus entre as hastes e folhas largas de orquídea na base. Uma fita larga de cetim verde-sálvia amarra o vidro num laço de pontas longas; dentro, casca de pinus até a boca. Tudo sobre a bancada de pinus cor de mel, contra a parede caiada clara, sob luz de estúdio limpa vinda da esquerda.',
  };

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function moeda(v) {
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* -------------------------------------------------------------- a sacola */

  var CHAVE = 'casaflores.sacola.v1';
  var sacola = [];

  /* O ALVO DA ENTREGA POR CONTA DA CASA — VALOR PROVISÓRIO, A CONFIRMAR.
     A faixa de mimos veio da referência mandada em 31/08/2026, que é de outra
     floricultura e usa o alvo DELA. A Casa Flores não tem política de entrega
     grátis confirmada: as 22 páginas do site atual não dizem nada a respeito, e
     o levantamento (10-catalogo-do-site-atual.md) já achou duas regras de
     entrega que se contradizem. Este número é uma casca — mexer aqui, num
     lugar só, muda a frase, a barra e o rótulo ao mesmo tempo.
     ENQUANTO O CLIENTE NÃO CONFIRMAR, a faixa não deve ir para o domínio da
     Casa Flores; na loja de demonstração ela é maquete. Pôr `0` desliga a
     faixa inteira, sem tirar markup de lugar nenhum. */
  var ENTREGA_GRATIS = 450;

  /* A sacola persiste SÓ id e quantidade. Nome, preço e foto são relidos do
     catálogo a cada pintura — se guardasse o preço, uma sacola aberta na
     semana passada fecharia o pedido pelo preço da semana passada, e numa
     floricultura o preço muda com o que o mercado cobrou naquela manhã.
     Consequência aceita: peça que sai do catálogo some da sacola. É o
     comportamento certo — ela também sumiu da loja. */
  /* AS PROPRIEDADES DA LINHA, e por que elas não são do pedido.
     O §4.2 do plano é explícito: data, janela, texto do cartão e quem recebe
     viajam com a LINHA até a expedição e a nota. "Duas peças no mesmo pedido
     podem ir para pessoas diferentes, em dias diferentes" — um site que amarra
     a data ao pedido inteiro quebra no primeiro cliente que manda dois buquês.

     A consequência prática está aqui: duas linhas da MESMA peça só viram
     quantidade 2 se TODAS as propriedades forem iguais. Data diferente, cartão
     diferente ou destinatário diferente = duas linhas. Somar quantidade
     nesse caso perderia um dos dois cartões, em silêncio. */
  var PROPS = ['data', 'janela', 'cartao', 'quem', 'fone'];

  /* A LEITURA GUARDA AS PROPRIEDADES DA LINHA — e ate 31/08/2026 ela as JOGAVA
     FORA. O `.map` devolvia `{id, qtd}` e mais nada, entao data, janela e texto
     do cartao morriam em toda troca de pagina: a pessoa escolhia tudo na peca,
     ia para o checkout, e o pedido chegava sem data e sem recado. Ninguem tinha
     visto porque, ate existir uma segunda pagina lendo a sacola, o dado so
     precisava sobreviver dentro da mesma aba.
     O comentario acima explica por que o PRECO nao e guardado — e o motivo e
     preco, nao propriedade: preco muda com o que o mercado cobrou na manha, um
     recado escrito nao muda. Guardar os dois pelo mesmo motivo era ler a regra
     pela metade. O corte de 400 caracteres e higiene: o que vem do
     `localStorage` e texto que o navegador guardou, nao dado de confianca. */
  try {
    var cru = JSON.parse(localStorage.getItem(CHAVE)) || [];
    sacola = cru
      .filter(function (l) { return l && l.id && l.qtd > 0; })
      .map(function (l) {
        var linha = { id: l.id, qtd: Math.min(l.qtd, 99) };
        PROPS.forEach(function (k) {
          if (l[k]) linha[k] = String(l[k]).slice(0, 400);
        });
        return linha;
      });
  } catch (e) { sacola = []; }

  function grava() {
    try { localStorage.setItem(CHAVE, JSON.stringify(sacola)); } catch (e) { /* modo privado */ }
  }

  function pecaDe(id) {
    return PECAS.filter(function (p) { return p.id === id; })[0] || null;
  }

  /* Linhas cuja peça não existe mais no catálogo são descartadas na leitura. */
  /* O `i` entra porque a sacola agora pode ter DUAS linhas da mesma peça, com
     data ou cartão diferentes (ver `poe`). Sem o índice, o +/- acha "a primeira
     com esse id" e mexe na linha errada — que é o tipo de defeito que só
     aparece com o cliente que manda dois buquês, exatamente o caso que o §4.2
     do plano manda cobrir. */
  function dataBonita(iso) {
    var p = String(iso).split('-');
    return p.length === 3 ? p[2] + '/' + p[1] : esc(iso);
  }

  function linhas() {
    return sacola
      .map(function (l, i) {
        var p = pecaDe(l.id);
        if (!p) return null;
        return { i: i, id: l.id, qtd: l.qtd, nome: p.nome, preco: p.preco, img: p.img || '',
                 data: l.data || '', janela: l.janela || '', cartao: l.cartao || '',
                 quem: l.quem || '', fone: l.fone || '' };
      })
      .filter(Boolean);
  }

  function conta() {
    return linhas().reduce(function (n, l) { return n + l.qtd; }, 0);
  }

  function total() {
    return linhas().reduce(function (n, l) { return n + l.qtd * l.preco; }, 0);
  }

  function mesmasProps(linha, dados) {
    for (var i = 0; i < PROPS.length; i++) {
      if ((linha[PROPS[i]] || '') !== ((dados && dados[PROPS[i]]) || '')) return false;
    }
    return true;
  }

  function poe(id, dados, silencioso) {
    var peca = pecaDe(id);
    if (!peca || peca.esgotada || soConsulta(peca)) return;
    var linha = sacola.filter(function (l) {
      return l.id === id && mesmasProps(l, dados);
    })[0];
    if (linha) { linha.qtd = Math.min(linha.qtd + 1, 99); }
    else {
      var nova = { id: peca.id, qtd: 1 };
      if (dados) {
        PROPS.forEach(function (k) { if (dados[k]) nova[k] = dados[k]; });
      }
      sacola.push(nova);
      linha = nova;
    }
    grava();
    pintaSacola();
    /* `silencioso` existe para o "Levar junto" da PDP: abrir a gaveta a cada
       caixa marcada tapa a própria fileira que a pessoa está lendo. O contador
       do cabeçalho já dá o retorno. */
    if (!silencioso) abre('sacola');
    return linha;
  }

  /* Com mais de uma linha do mesmo id, achar "a primeira com esse id" mexe na
     linha errada. O índice resolve sem inventar chave nova. */
  function mexe(id, d) {
    var i = /^\d+$/.test(String(id)) ? Number(id) : indiceDe(id);
    var linha = sacola[i];
    if (!linha) return;
    linha.qtd += d;
    /* TIRAR PELO ÍNDICE, NÃO PELO id. Até 31/08/2026 esta linha era
       `sacola.filter(l => l.id !== id)`, e `id` aqui é o ÍNDICE — nenhuma peça
       tem id '0'. Resultado: o `–` na quantidade 1 zerava o número e a linha
       FICAVA na gaveta escrita "0", porque `linhas()` não filtra quantidade. Só
       sumia no reload, onde a leitura do localStorage descarta `qtd < 1`. O
       defeito ficou escondido enquanto tirar peça era um caminho torto; com a
       lixeira ao lado ele apareceria no primeiro clique. */
    if (linha.qtd < 1) sacola.splice(i, 1);
    grava();
    pintaSacola();
  }

  function indiceDe(id) {
    for (var i = 0; i < sacola.length; i++) { if (sacola[i].id === id) return i; }
    return -1;
  }

  /* A lixeira tira a LINHA inteira, seja qual for a quantidade. É a única saída
     honesta para quem pôs 3 e quer 0: pelo `–` são três cliques e uma aposta. */
  function tira(i) {
    i = Number(i);
    if (!sacola[i]) return;
    sacola.splice(i, 1);
    grava();
    pintaSacola();
  }

  function pintaSacola() {
    var n = conta();
    $$('[data-contador]').forEach(function (el) { el.textContent = n; });
    $$('[data-badge]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.setAttribute('data-tem', ''); else el.removeAttribute('data-tem');
    });

    var corpo = $('[data-sacola-corpo]');
    var pe = $('[data-sacola-pe]');
    if (!corpo) return;

    var itens = linhas();
    if (!itens.length) {
      /* A GAVETA VAZIA GANHOU UMA SAÍDA. Antes daqui só o X era clicável, e
         fechar não é o que se quer que a pessoa faça. O botão volta para a
         loja; `data-fecha` existe para o caso de ela JÁ estar na PLP, onde o
         link não navega para lugar nenhum visível e a gaveta ficaria aberta
         por cima da grade que ela pediu para ver. */
      corpo.innerHTML =
        '<div class="vazio">' +
          '<svg width="44" height="44" viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
            'stroke-width="1.2" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M4 6h12l-1 11H5L4 6Z"/><path d="M7.5 6V4.5a2.5 2.5 0 0 1 5 0V6"/></svg>' +
          '<b>A sacola está vazia</b>' +
          '<p>As peças mudam com o que chegou bom na manhã. Vale olhar o que está na bancada.</p>' +
          '<a class="btn btn--primaria" href="/collections/all" data-fecha>Ver a loja</a>' +
        '</div>';
      corpo.classList.add('gaveta__corpo--vazio');
      if (pe) pe.classList.add('oculto');
      /* A FAIXA CONTINUA PINTANDO COM A SACOLA VAZIA, e é o ponto dela: é a
         única linha da gaveta vazia que dá um motivo para voltar para a loja. */
      pintaMimo(0);
      return;
    }
    corpo.classList.remove('gaveta__corpo--vazio');

    corpo.innerHTML = itens.map(function (l) {
      return '' +
        '<div class="linha">' +
          miniDaPeca(l) +
          '<div>' +
            '<p class="linha__n">' + esc(l.nome) + '</p>' +
            (l.data || l.janela || l.quem || l.cartao
              ? '<p class="linha__d">' +
                  [l.data ? dataBonita(l.data) : '', l.janela, l.quem ? 'para ' + esc(l.quem) : '']
                    .filter(Boolean).join(' · ') +
                  (l.cartao ? '<br>com cartão' : '') +
                '</p>'
              : '') +
            '<div class="linha__qtd">' +
              '<button type="button" data-menos="' + l.i + '" aria-label="Tirar um">–</button>' +
              '<span class="qtd">' + l.qtd + '</span>' +
              '<button type="button" data-mais="' + l.i + '" aria-label="Pôr mais um">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="linha__lado">' +
            '<button class="linha__tira" type="button" data-tira="' + l.i + '" ' +
              'aria-label="Tirar ' + esc(l.nome) + ' da sacola">' +
              '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
                'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M3.5 5.5h13"/><path d="M8 5.5V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5"/>' +
                '<path d="M5.5 5.5 6.3 17h7.4l.8-11.5"/><path d="M8.5 8.5v5.5M11.5 8.5v5.5"/></svg>' +
            '</button>' +
            '<span class="preco">' + moeda(l.qtd * l.preco) + '</span>' +
          '</div>' +
        '</div>';
    }).join('');

    var sub = total();
    if (pe) {
      pe.classList.remove('oculto');
      /* Subtotal e Total mostram o MESMO número enquanto a entrega for
         "calculada no fim", e as duas linhas existem assim mesmo: é o subtotal
         que a pessoa confere contra o que ela pôs, e é o total que ela leva
         para o checkout. Quando a entrega passar a ter preço, só o Total muda
         — nenhuma das duas linhas precisa nascer depois. */
      var st = $('[data-subtotal]', pe);
      if (st) st.textContent = moeda(sub);
      var t = $('[data-total]', pe);
      if (t) t.textContent = moeda(sub);
    }
    pintaMimo(sub);
    /* A gaveta continua existindo NA pagina de fechar o pedido: tirar uma peca
       por ela tem de mudar o resumo e a conferencia atras dela, senao a pessoa
       manda para a casa um pedido com a peca que acabou de remover. O estado
       dos campos nao se perde porque o estado da entrega mora em `ckEntrega`,
       fora do DOM. */
    if (typeof pintaCheckout === 'function') pintaCheckout();
  }

  /* A FAIXA DE MIMOS. Uma função só pinta os dois estados da gaveta porque o
     único dado que ela lê é o subtotal — 0 na sacola vazia. */
  function pintaMimo(sub) {
    var faixa = $('[data-mimo]');
    if (!faixa) return;

    if (!(ENTREGA_GRATIS > 0)) { faixa.classList.add('oculto'); return; }
    faixa.classList.remove('oculto');

    var falta = Math.max(0, ENTREGA_GRATIS - sub);
    var frase = $('[data-mimo-frase]', faixa);
    var barra = $('[data-mimo-preenche]', faixa);
    var valor = $('[data-mimo-valor]', faixa);
    var leg   = $('.mimo__leg', faixa);

    if (frase) {
      frase.innerHTML = falta > 0
        ? 'Faltam <b>' + esc(moeda(falta)) + '</b> para a entrega por conta da casa'
        : 'A entrega vai <b>por conta da casa</b>';
    }
    if (barra) {
      barra.style.width = Math.min(100, (sub / ENTREGA_GRATIS) * 100).toFixed(1) + '%';
    }
    /* O rótulo do alvo vai sem centavos: são sempre dois zeros e ele mora num
       espaço de 13px, embaixo do filete. `moeda()` continua sendo a fonte do
       formato — inclusive do separador de milhar, que aparece assim que o alvo
       passar de mil. */
    if (valor) valor.textContent = moeda(ENTREGA_GRATIS).replace(/,00$/, '');
    if (leg) {
      leg.textContent = falta > 0
        ? 'Junte peças até o alvo e a entrega vai por conta da casa.'
        : 'Pronto: a entrega desta sacola já está por conta da casa.';
    }
  }

  /* -------------------------------------------------------------- as gavetas */

  var abertaAgora = null;
  var focoAnterior = null;

  var FOCAVEL = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function focaveis(raiz) {
    return $$(FOCAVEL, raiz).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function abre(qual) {
    var g = $('[data-gaveta="' + qual + '"]');
    if (!g) return;
    if (abertaAgora && abertaAgora !== g) fecha();
    focoAnterior = document.activeElement;
    g.setAttribute('data-aberto', '');
    g.removeAttribute('aria-hidden');
    var v = $('[data-veu]');
    if (v) v.setAttribute('data-aberto', '');
    document.body.style.overflow = 'hidden';
    abertaAgora = g;
    /* O resto da página sai do alcance do leitor de tela e do Tab enquanto a
       gaveta está aberta. Sem isto o usuário de teclado sai da gaveta pelo Tab
       e continua navegando por trás do véu, sem nenhum sinal de que saiu. */
    $$('body > *').forEach(function (el) {
      if (el === g || el.hasAttribute('data-veu')) return;
      if (el.tagName === 'SCRIPT') return;
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    });
    var alvo = focaveis(g)[0];
    if (alvo) alvo.focus();
  }

  function fecha() {
    if (!abertaAgora) return;
    var g = abertaAgora;
    abertaAgora = null;
    g.removeAttribute('data-aberto');
    var v = $('[data-veu]');
    if (v) v.removeAttribute('data-aberto');
    document.body.style.overflow = '';
    $$('body > *').forEach(function (el) {
      el.removeAttribute('inert');
      el.removeAttribute('aria-hidden');
    });
    if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
    focoAnterior = null;
  }

  /* Laço de Tab dentro da gaveta. `inert` já resolve nos navegadores que o
     suportam; este laço é a rede para os que não suportam, e é ele que faz o
     Tab voltar ao começo em vez de sair para a barra do navegador. */
  function prendeFoco(ev) {
    if (!abertaAgora || ev.key !== 'Tab') return;
    var lista = focaveis(abertaAgora);
    if (!lista.length) return;
    var primeiro = lista[0], ultimo = lista[lista.length - 1];
    if (ev.shiftKey && document.activeElement === primeiro) {
      ev.preventDefault(); ultimo.focus();
    } else if (!ev.shiftKey && document.activeElement === ultimo) {
      ev.preventDefault(); primeiro.focus();
    }
  }

  /* --------------------------------------------------------------- pinturas */

  /* ------------------------------------------------- O QUE NÃO TEM PEÇA SOME
     A vitrine é preenchida por família, conforme o cliente manda o catálogo real,
     então **há sempre uma categoria que existe no negócio e ainda não tem peça
     no site**. Link de menu que abre grade vazia é promessa que a loja não
     cumpre, e chip de filtro que sempre devolve zero é pior que filtro nenhum.

     Por que isto é código e não edição de marcacão: os links de categoria estão
     em TRÊS lugares por página (cabeçalho, rodapé, menu do celular) em cinco
     páginas — 15 no total. Apagá-los à mão significaria reescrevê-los à mão
     quando a família chegar. Derivando do catálogo, some e volta sozinho.

     `jardim` é a exceção e já estava resolvida: ela tem `rota` porque é SERVIÇO
     e nunca teve peça na grade. Categoria com `rota` nunca some. */
  function contaDaCategoria(id) {
    return PECAS.filter(function (p) { return p.cat === id; }).length;
  }

  function categoriaVisivel(c) {
    return !!c.rota || !!c.aCaminho || contaDaCategoria(c.id) > 0;
  }

  function recolheVazios() {
    /* Os links morrem por `remove()` e não por `hidden`: o `[hidden]` perde para
       o `display:` que a classe do menu já declara, e o link continuaria visível.
       Some também o `<li>` do rodapé quando o link era o único conteúdo dele —
       senão fica um marcador de lista sozinho na coluna. */
    var vazias = CATEGORIAS.filter(function (c) { return !categoriaVisivel(c); })
                           .map(function (c) { return c.id; });
    if (!vazias.length) return;
    $$('a[href*="cat="]').forEach(function (a) {
      var id = (a.getAttribute('href') || '').split('cat=')[1];
      if (vazias.indexOf(decodeURIComponent(id || '')) === -1) return;
      var pai = a.parentNode;
      if (pai && pai.tagName === 'LI' && pai.children.length === 1) pai.remove();
      else a.remove();
    });
  }

  function pintaCategorias() {
    var alvo = $('[data-categorias]');
    if (!alvo) return;
    alvo.innerHTML = CATEGORIAS.filter(categoriaVisivel).map(function (c) {
      var rota = c.rota || ('/collections/all?cat=' + c.id);
      return '' +
        '<a class="cat" href="' + rota + '">' +
          '<img src="' + esc(c.img) + '" alt="" loading="lazy" decoding="async">' +
          '<span class="cat__cap">' +
            '<span class="cat__n">' + esc(c.nome) + '</span>' +
            '<span class="cat__d">' + esc(c.d) + '</span>' +
          '</span>' +
        '</a>';
    }).join('');
  }

  /* ------------------------------------------------------- PEÇA SEM FOTO
     A peça que ainda não foi fotografada não empresta a foto de outra: ela
     desenha o MOLDE, a mesma caixa de canto marcado que a `.sobrecat` usa para
     foto a produzir. A caixa diz a medida do master que falta, e não o nome da
     peça: o nome está na linha logo abaixo, em Fraunces, e escrevê-lo duas vezes
     num cartão de 252px foi o que a primeira foto da grade mostrou sobrando.

     Devolve `<div>` e não `<figure>` de propósito: esta função pinta tanto o
     miolo de `.peca__fig` (um div) quanto o de `.pdp__fig` (que JÁ é um figure),
     e figure dentro de figure leria como duas ilustrações empilhadas.

     A TROCA POR FOTO REAL É EDIÇÃO DE DADO, NÃO DE MARKUP — a mesma regra do
     `molde()` da vitrine: volta o `img:` no objeto da peça e nada aqui muda. */
  function semFoto(p) { return !p || (!p.img && !p.img2); }

  /* `img2` é a foto que aparece ao passar o mouse no cartão — o detalhe da flor,
     contra a capa que mostra a peça inteira.

     A REGRA QUE EVITA CARTÃO MUDO: peça com `img2` e SEM `img` promove a segunda
     a capa. Em 16/09/2026 as fotos de detalhe das quatro mini orquídeas ficaram
     prontas antes das capas de estúdio de três delas; sem esta linha, `p3`, `p6`
     e `p8` continuariam desenhando o molde "Foto a caminho" com uma foto boa
     escondida atrás do hover — pior do que não ter o hover. Quando a capa chegar,
     basta acrescentar `img:` na peça e o hover liga sozinho, sem tocar em mais
     nada.

     O hover é opt-in (`comHover`) porque `figuraDaPeca` também serve a `.junto__i`
     do "levar junto", que não é `position:relative` — uma segunda imagem absoluta
     ali escaparia da caixa. */
  function figuraDaPeca(p, ar, comHover) {
    var razao = ar || '4/5';
    if (!semFoto(p)) {
      var capa = p.img, hover = p.img2;
      if (!capa) { capa = hover; hover = null; }
      var tagHover = (comHover && hover)
        ? '<img class="peca__fig-hover" src="' + esc(hover) + '" alt="" ' +
          'loading="lazy" decoding="async" aria-hidden="true">'
        : '';
      return '<img src="' + esc(capa) + '" alt="' +
             esc(FOTO_ALT[capa] || 'Foto de processo da Casa Flores.') +
             '" loading="lazy" decoding="async">' + tagHover;
    }
    return '<div class="molde molde--peca" style="--ar:' + razao + '">' +
             '<p class="molde__txt">' +
               '<span class="rotulo">Foto a caminho</span>' +
               '<span class="molde__meta">Master ' + razao.replace('/', ':') +
                 ' \u00b7 ainda n\u00e3o fotografada</span>' +
             '</p>' +
           '</div>';
  }

  /* A miniatura da sacola e do fechamento é pequena demais para prosa: 68 por 85
     não cabe nem o nome. Ali o molde é só a caixa vazia com a borda de controle
     — o nome da peça está na linha ao lado, que é quem responde "o que é isto". */
  function miniDaPeca(l) {
    if (l && l.img) return '<img src="' + esc(l.img) + '" alt="">';
    return '<span class="mini-molde" aria-hidden="true"></span>';
  }

  /* ------------------------------------------------- A MOLDURA DA CATEGORIA
     O cartão que ocupa o lugar das peças numa categoria `aCaminho`. É o mesmo
     molde do cartão sem foto — a caixa de canto marcado —, porque a pergunta é a
     mesma vista de outro ângulo: ali falta a FOTO de uma peça que existe, aqui
     falta a PEÇA inteira. Um só desenho para as duas faltas mantém a leitura.

     Só aparece com a categoria limpa: com busca, filtro de flor ou de permanência
     em cima, quem não achou nada não achou por causa do RECORTE, e aí a resposta
     certa é o "nada com esse recorte hoje" — que sugere tirar um filtro. */
  function molduraDaCategoria(estado) {
    if (!estado || estado.busca || estado.perm || estado.flor || !estado.cat) return '';
    var c = CATEGORIAS.filter(function (x) { return x.id === estado.cat; })[0];
    if (!c || !c.aCaminho || contaDaCategoria(c.id) > 0) return '';
    return '' +
      '<article class="peca peca--moldura">' +
        '<div class="peca__fig">' +
          '<div class="molde molde--peca" style="--ar:4/5">' +
            '<p class="molde__txt">' +
              '<span class="rotulo">Peças a caminho</span>' +
              '<span class="molde__meta">' + esc(c.nome) + ' · nome e foto com a casa</span>' +
            '</p>' +
          '</div>' +
        '</div>' +
        '<div class="peca__corpo">' +
          '<h3 class="peca__n">' + esc(c.nome) + ' entram aqui</h3>' +
          '<p class="peca__r">' + esc(c.d) + ' A casa está fechando os nomes e as fotos.</p>' +
        '</div>' +
      '</article>';
  }

  function floresDoCatalogo() {
    var vistas = [];
    PECAS.forEach(function (p) {
      if (p.flor && vistas.indexOf(p.flor) === -1) vistas.push(p.flor);
    });
    return vistas.join(', ');
  }

  /* SOB CONSULTA (23/09/2026). As plantas de chão entraram no site antes do preço:
     o Erik pediu no ar já, e o valor não existe em lugar nenhum do projeto — nem no
     catálogo do Wix, nem no Drive. Inventar número é a única coisa proibida aqui.
     Peça com `preco: null` não vai para a sacola (o checkout cobraria R$ 0): o cartão
     e a PDP trocam preço por "Sob consulta" e o botão pelo WhatsApp da casa. Quando
     o preço chegar, é pôr o número na peça e tudo volta a ser sacola. */
  var WHATS_CONSULTA = 'https://wa.me/5511911093492?text=';
  function soConsulta(p) { return !p || p.preco === null || p.preco === undefined; }
  function linkConsulta(p) {
    return WHATS_CONSULTA + encodeURIComponent('Oi. Vi a ' + p.nome + ' no site e queria saber o preço e o porte.');
  }

  function cartao(p) {
    var esgotada = !!p.esgotada;
    return '' +
      '<article class="peca' + (esgotada ? ' peca--esgotada' : '') + '">' +
        '<a class="peca__link" href="' + hrefPeca(p.id) + '">' +
        '<div class="peca__fig">' +
          (esgotada ? '<span class="selo">Acabou hoje</span>' : '') +
          figuraDaPeca(p, '4/5', true) +
        '</div>' +
        '</a>' +
        '<div class="peca__corpo">' +
          '<span class="peca__cat">' + esc(p.permanencia) + '</span>' +
          '<h3 class="peca__n"><a href="' + hrefPeca(p.id) + '">' + esc(p.nome) + '</a></h3>' +
          '<p class="peca__r">' + esc(p.resumo) + '</p>' +
          '<div class="peca__pe"><span class="preco">' + (soConsulta(p) ? 'Sob consulta' : moeda(p.preco)) + '</span></div>' +
          '<div class="peca__add">' +
            (soConsulta(p)
              ? '<a class="btn btn--primaria btn--bloco" href="' + linkConsulta(p) + '" target="_blank" rel="noopener">Consultar preço</a>'
              : esgotada
              ? '<button class="btn btn--primaria btn--bloco" type="button" disabled>Acabou hoje</button>'
              : '<button class="btn btn--primaria btn--bloco" type="button" data-poe="' + p.id + '">Pôr na sacola</button>') +
          '</div>' +
        '</div>' +
      '</article>';
  }

  /* ==================================================================
     A PÁGINA DA PEÇA
     ==================================================================
     Ordem e conteúdo saem do §4.2 do plano. O que esta função NÃO faz é tão
     decidido quanto o que ela faz:

     · não inventa horário de corte — o §5 do plano o marca `A CONFIRMAR` e o
       doc 40 proíbe citar prazo antes de área coberta e corte existirem;
     · não inventa variação de tamanho — o doc 10 apurou que nenhuma das 54
       peças do catálogo real tem variação, e preço por tamanho seria dado
       comercial fabricado;
     · não converte nada do texto do cartão. O plano é duro nisto: o que o
       cliente aprova na tela é byte a byte o que sai impresso.
     ================================================================== */
  function pintaPDP() {
    var raiz = $('[data-pdp]');
    if (!raiz) return;

    var q = paramsDaUrl();
    var idPeca = raiz.getAttribute('data-peca') || q.peca || '';
    /* Link antigo /pages/produto?peca=p3 (WhatsApp, favoritos, sacola): se a peça
       já tem URL própria, vai para ela. replace, para não sujar o histórico. */
    if (!raiz.getAttribute('data-peca') && HANDLES[idPeca]) {
      location.replace('/products/' + HANDLES[idPeca]);
      return;
    }
    var peca = pecaDe(idPeca);
    var vazio = $('[data-pdp-vazio]');

    if (!peca) { if (vazio) vazio.hidden = false; return; }
    raiz.hidden = false;
    /* v58: em /products/ o title vem do servidor (SEO da Admin). Só o legado
       /pages/produto?peca= (sem data-peca) ganha title pelo JS. */
    if (!raiz.getAttribute('data-peca')) document.title = peca.nome + ' · Casa Flores';

    var img = $('[data-pdp-img]');
    if (img) {
      if (semFoto(peca)) {
        /* Troca o `<img>` inteiro pelo molde. `replaceChild` e não `innerHTML`
           do pai porque a `.pdp__fig` pode ganhar outros filhos depois, e
           limpar o pai levaria junto o que não é a foto. */
        var molde = document.createElement('div');
        molde.innerHTML = figuraDaPeca(peca, '4/5');
        if (img.parentNode && molde.firstChild) {
          img.parentNode.replaceChild(molde.firstChild, img);
        }
      } else {
        img.src = peca.img;
        img.alt = FOTO_ALT[peca.img] || ('Foto da peça ' + peca.nome + ', montada na Casa Flores.');
      }
    }
    var pt = function (sel, txt) { var e = $(sel); if (e) e.textContent = txt; };
    pt('[data-pdp-cat]', peca.permanencia);
    pt('[data-pdp-nome]', peca.nome);
    pt('[data-pdp-resumo]', peca.resumo || '');
    pt('[data-pdp-preco]', soConsulta(peca) ? 'Preço sob consulta' : moeda(peca.preco));
    if (soConsulta(peca)) {
      /* Sem preço não há linha de pedido: data, janela e cartão são propriedades da
         LINHA, então somem com ela. O botão vira o WhatsApp da casa. */
      ['[data-pdp-data]', '[data-pdp-janela]'].forEach(function (sel) {
        var el = $(sel); var bloco = el && el.closest('.campo'); if (bloco) bloco.style.display = 'none';
      });
      var cartaoBloco = $('.compra .cartao'); if (cartaoBloco) cartaoBloco.style.display = 'none';
      var prazo = $('.compra .prazo'); if (prazo) prazo.style.display = 'none';
      var poeBtn = $('[data-pdp-poe]');
      if (poeBtn) {
        var zap = document.createElement('a');
        zap.className = poeBtn.className; zap.href = linkConsulta(peca);
        zap.target = '_blank'; zap.rel = 'noopener'; zap.textContent = 'Consultar no WhatsApp';
        poeBtn.replaceWith(zap);
      }
    }

    /* "O que vem" e "como cuidar" saem da espécie e da permanência, que são os
       campos que a peça realmente tem. Sem inventar composição fechada: a
       cláusula de substituição, no acordeão ao lado, já diz que a lista é do
       dia — e descrever por tipo e paleta, e não por espécie fechada, é o que
       torna a cláusula honesta em vez de defensiva (§3 do plano). */
    var vem = $('[data-pdp-vem]');
    if (vem) {
      vem.innerHTML =
        '<p>' + esc(peca.resumo || '') + '</p>' +
        (peca.cat === 'plantas-de-chao' ? '' :
          '<p>Flor principal: ' + esc(peca.flor) + '. Montada na bancada no dia em que sai, ' +
            'com o que chegou bom no mercado naquela manhã.</p>') +
        /* 28/09/2026: vale para TODA peça que é planta em vaso (plantas de chão,
           orquídeas e arranjos de mini orquídea), não só plantas de chão. O vaso
           nem sempre é plástico (pedido do Erik), então a frase não diz o material. */
        (peca.permanencia === 'planta viva'
          ? '<p><b>Vai no vaso da própria planta, sem vaso decorativo.</b></p>'
          : '');
    }
    /* 25/09/2026: o aviso do vaso mora nas ABAS da página, não na descrição do
       cartão (pedido do Erik). Aqui ele repete em "Entrega e troca". */
    var entrega = $('[data-pdp-entrega]');
    if (entrega && peca.permanencia === 'planta viva') {
      entrega.insertAdjacentHTML('afterbegin',
        '<p><b>A planta vai no vaso da própria planta, sem vaso decorativo.</b></p>');
    }
    var cuidado = $('[data-pdp-cuidado]');
    if (cuidado) {
      cuidado.innerHTML = peca.cat === 'plantas-de-chao'
        ? '<p>Luz clara e indireta. Regue quando a terra secar dois dedos para baixo e ' +
          'nunca deixe água parada no prato.</p>' +
          '<p>Se preferir não lembrar disso, a gente passa para cuidar: é o mesmo combinado ' +
          'que a casa faz em escritório.</p>'
        : peca.permanencia === 'planta viva'
        ? '<p>Luz indireta, sem sol direto na folha. Regue quando o substrato secar no dedo e ' +
          'escorra o excesso — planta em vidro não gosta de água parada no fundo.</p>' +
          '<p>Se preferir não lembrar disso, a gente passa para cuidar: é o mesmo combinado ' +
          'que a casa faz em escritório.</p>'
        : '<p>Troque a água a cada dois dias e corte um dedo do talo na diagonal a cada troca. ' +
          'Longe do sol direto e de fruta madura, que acelera a abertura.</p>' +
          '<p>Flor de corte é perecível: a peça rende mais em lugar fresco e fora do vento do ar-condicionado.</p>';
    }

    /* Data: o passado fica BLOQUEADO, não avisado (§4.2 item 5). Domingo
       também, porque a casa não entrega — descobrir isso depois de escolher é
       a tela que o §4.1 chama de pior possível. */
    var campoData = $('[data-pdp-data]');
    if (campoData) {
      var hoje = new Date();
      var iso = function (d) {
        return d.getFullYear() + '-' +
               String(d.getMonth() + 1).padStart(2, '0') + '-' +
               String(d.getDate()).padStart(2, '0');
      };
      /* 25/09/2026: a casa NÃO entrega no mesmo dia do pedido — o mínimo é amanhã. */
      var amanha = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 1);
      campoData.min = iso(amanha);
      campoData.addEventListener('change', function () {
        if (!campoData.value) { campoData.setCustomValidity(''); return; }
        var p = campoData.value.split('-');
        var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
        if (d < amanha) {
          campoData.setCustomValidity('A casa não entrega no mesmo dia do pedido. Escolha a partir de amanhã.');
          campoData.reportValidity();
          campoData.value = '';
        } else if (d.getDay() === 0) {
          campoData.setCustomValidity('A casa não entrega no domingo. Escolha outro dia.');
          campoData.reportValidity();
          campoData.value = '';
        } else {
          campoData.setCustomValidity('');
        }
      });
    }

    var janela = '';
    var cxJanela = $('[data-pdp-janela]');
    if (cxJanela) {
      cxJanela.addEventListener('click', function (ev) {
        var b = ev.target.closest ? ev.target.closest('[data-janela]') : null;
        if (!b) return;
        var v = b.getAttribute('data-janela');
        janela = (janela === v) ? '' : v;
        $$('[data-janela]', cxJanela).forEach(function (x) {
          x.setAttribute('aria-pressed', x.getAttribute('data-janela') === janela ? 'true' : 'false');
        });
      });
    }

    /* O texto do cartão vai para o pedido exatamente como foi digitado — sem
       trim, sem colapsar espaço, sem converter caixa. O contador conta
       caracteres, não valida nada. */
    var campoCartao = $('[data-pdp-cartao]');
    var conta = $('[data-pdp-conta]');

    /* O campo do cartão fica ABAIXO do botão, e o botão abre a gaveta: sem
       isto, quem volta e escreve o recado depois de pôr na sacola mandaria a
       peça sem cartão nenhum, sem nunca ver o erro. A linha que o botão
       devolveu continua editável enquanto a página estiver aberta. */
    var linhaPosta = null;

    if (campoCartao) {
      campoCartao.addEventListener('input', function () {
        if (conta) conta.textContent = String(campoCartao.value.length);
        if (!linhaPosta) return;
        if (campoCartao.value) linhaPosta.cartao = campoCartao.value;
        else delete linhaPosta.cartao;
        grava();
        pintaSacola();
      });
    }

    var botao = $('[data-pdp-poe]');
    if (botao) {
      botao.addEventListener('click', function () {
        /* Destinatário e telefone saíram da PDP: são coletados no fim, junto
           com o endereço e o pagamento. A LINHA continua carregando os campos
           — vazios aqui, preenchidos no fechamento — porque quem recebe é
           propriedade da linha, não do pedido. */
        linhaPosta = poe(peca.id, {
          data: campoData ? campoData.value : '',
          janela: janela,
          cartao: campoCartao ? campoCartao.value : ''
        }) || null;
      });
    }

    /* LEVAR JUNTO. São peças REAIS do catálogo — as três mais baratas que não
       a aberta, sem as esgotadas — e não um cadastro paralelo de brinde. O
       corte é por PREÇO, e não por "quem viu também viu": o §3.4 do plano
       proíbe recomendação por comportamento, que é exatamente onde condolência
       encosta em aniversário. */
    var extras = PECAS.filter(function (x) {
      return x.id !== peca.id && !x.esgotada && !soConsulta(x);
    }).sort(function (a, b) { return a.preco - b.preco; }).slice(0, 3);

    var secJunto = $('[data-pdp-junto]');
    var gradeJunto = $('[data-pdp-junto-grade]');
    if (extras.length && secJunto && gradeJunto && !soConsulta(peca)) {
      secJunto.hidden = false;
      gradeJunto.innerHTML = extras.map(function (o) {
        return '<label class="junto__i">' +
          figuraDaPeca(o, '1/1') +
          '<span class="junto__m">' +
            '<input type="checkbox" data-junto="' + esc(o.id) + '">' +
            '<span>Levar</span>' +
          '</span>' +
          '<span class="junto__n">' + esc(o.nome) + '</span>' +
          '<span class="junto__p">+ ' + moeda(o.preco) + '</span>' +
        '</label>';
      }).join('');

      /* DESMARCAR DESFAZ A MESMA LINHA QUE FOI CRIADA, guardada por
         referência. Procurar depois "a primeira linha com esse id" mexeria na
         linha que a pessoa JÁ tinha na sacola de antes — com data, janela e
         bilhete próprios — e tiraria de lá um pedido que ela não desmarcou.
         E se a peça esgotar entre a pintura e o clique, `poe` devolve undefined
         e a caixa volta sozinha para desmarcada em vez de mentir. */
      var linhasJunto = {};
      $$('[data-junto]', gradeJunto).forEach(function (cx) {
        cx.addEventListener('change', function () {
          var id = cx.getAttribute('data-junto');
          if (cx.checked) {
            linhasJunto[id] = poe(id, null, true) || null;
            if (!linhasJunto[id]) cx.checked = false;
            return;
          }
          var linha = linhasJunto[id];
          if (!linha) return;
          linha.qtd -= 1;
          if (linha.qtd < 1) {
            sacola = sacola.filter(function (x) { return x !== linha; });
          }
          linhasJunto[id] = null;
          grava();
          pintaSacola();
        });
      });
    }
  }

  function pintaDestaques() {
    var alvo = $('[data-destaques]');
    if (!alvo) return;
    var n = parseInt(alvo.getAttribute('data-destaques'), 10) || PECAS.length;
    alvo.innerHTML = PECAS.slice(0, n).map(cartao).join('');
  }

  /* ------------------------------------------------------ a esteira da faixa

     Ritmo em PIXELS POR SEGUNDO, não em duração fixa. Com duração fixa a
     esteira anda mais rápido quanto mais texto ela carrega, e trocar uma
     palavra na redação mudaria a velocidade da faixa inteira sem ninguém
     pedir. 42px/s é passo de leitura: a frase mais longa atravessa a tela
     inteira em pouco mais de meio minuto, e o olho acompanha sem perseguir. */
  var VELOCIDADE = 42;
  var grupoHTML = '';
  var grupoLargura = 0;

  function pintaGarantias() {
    var trilho = $('[data-garantias]');
    if (!trilho) return;

    grupoHTML = GARANTIAS.map(function (g) {
      return '<span class="garantias__item">' +
               '<svg class="garantias__ico" width="17" height="17" viewBox="0 0 20 20" ' +
                    'fill="none" stroke="currentColor" stroke-width="1.5" ' +
                    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
                    'focusable="false">' + ICONES[g.ico] + '</svg>' +
               '<span>' + esc(g.t) + '</span>' +
             '</span>';
    }).join('');

    /* Uma cópia é o conteúdo; as outras existem só para tapar a tela enquanto
       o trilho volta ao começo, e por isso saem da árvore de acessibilidade —
       senão o leitor de tela anuncia as mesmas quatro frases quatro vezes. */
    trilho.innerHTML = '<span class="garantias__grupo">' + grupoHTML + '</span>';

    grupoLargura = trilho.firstChild.getBoundingClientRect().width;
    if (!grupoLargura) return;   /* fonte ainda não chegou: fica parado, e parado é legível */

    completaEsteira(trilho);
    trilho.style.setProperty('--corre-dist', grupoLargura.toFixed(2) + 'px');
    trilho.style.setProperty('--corre-dur', (grupoLargura / VELOCIDADE).toFixed(1) + 's');
    trilho.setAttribute('data-esteira', '');
  }

  /* O trilho precisa medir uma cópia MAIS uma tela: no instante em que ele
     recuou uma cópia inteira, o que aparece na direita ainda tem que ser
     conteúdo, não fundo. Só acrescenta cópias, nunca tira — remover no meio da
     animação daria salto, e uma cópia sobrando não custa nada. */
  function completaEsteira(trilho) {
    if (!grupoLargura) return;
    var precisa = Math.ceil(window.innerWidth / grupoLargura) + 1;
    var falta = '';
    for (var i = trilho.children.length; i < precisa; i++) {
      falta += '<span class="garantias__grupo" aria-hidden="true">' + grupoHTML + '</span>';
    }
    if (falta) trilho.insertAdjacentHTML('beforeend', falta);
  }

  /* Alargar a janela pode descobrir o fim do trilho. Só completa — não remede
     e não repinta, para a esteira não dar um pulo a cada arrasto da borda. */
  var esperaLargura;
  window.addEventListener('resize', function () {
    clearTimeout(esperaLargura);
    esperaLargura = setTimeout(function () {
      var trilho = $('[data-garantias]');
      if (trilho) completaEsteira(trilho);
    }, 200);
  });

  /* ------------------------------------------------------------------- PLP
     O plano (01 §3.1) inverte o site atual: espécie NÃO é rota, é filtro — com a
     única exceção da orquídea, cujo motivo está escrito no cabeçalho de `CATEGORIAS`.
     `permanencia` — flor de corte contra planta viva — é o posicionamento da
     marca virado filtro, e por isso é o primeiro da fila, não o último. */

  /* ROTA APOSENTADA CONTINUA ABRINDO A VITRINE CERTA. Em 16/09/2026 a categoria
     `plantas` virou `orquideas`, e o site já está no ar: link guardado, print
     mandado no WhatsApp e resultado de busca continuam apontando para
     `?cat=plantas`. Sem este de-para, essa URL cai numa grade de zero peça com o
     estado vazio pedindo "tire um filtro" — a loja parece sem estoque justamente
     para quem já tinha vindo. É o 301 do §7 do plano feito do lado do cliente,
     que é o único lado que este site tem.
     Uma linha por rota aposentada; nunca se apaga uma, só se acrescenta. */
  var CAT_APOSENTADA = { plantas: 'orquideas' };

  /* URL DA PEÇA. O SKU de cada produto da Shopify é o id da peça (p3, p37…), e o
     layout publica o par em `window.CF_HANDLES`. Peça com produto na loja vive em
     /products/<handle> (título, preço e JSON-LD no HTML, que é o que o Google lê);
     peça sem produto continua em /pages/produto?peca=, que é noindex. */
  var HANDLES = window.CF_HANDLES || {};
  function hrefPeca(id) {
    return HANDLES[id] ? '/products/' + HANDLES[id] : '/pages/produto?peca=' + encodeURIComponent(id);
  }

  function paramsDaUrl() {
    var q = {};
    (location.search || '').replace(/^\?/, '').split('&').forEach(function (par) {
      if (!par) return;
      var p = par.split('=');
      q[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
    });
    if (q.cat && CAT_APOSENTADA[q.cat]) q.cat = CAT_APOSENTADA[q.cat];
    return q;
  }

  function pintaPLP() {
    var grade = $('[data-plp]');
    if (!grade) return;

    var q = paramsDaUrl();
    var estado = { cat: q.cat || '', perm: q.perm || '', flor: q.flor || '',
                   busca: (q.q || '').trim() };

    var titulo = $('[data-plp-titulo]');
    var conta  = $('[data-plp-conta]');
    var chips  = $('[data-plp-filtros]');
    var sobre  = $('[data-sobrecat]');

    function nomeCat(id) {
      var c = CATEGORIAS.filter(function (x) { return x.id === id; })[0];
      return c ? c.nome : 'A loja inteira';
    }

    /* CHIP QUE SEMPRE DEVOLVE ZERO NÃO É FILTRO. Os nove chips estão escritos à
       mão na `/collections/all` e cobrem os três eixos do catálogo; conforme a vitrine
       muda de composição, alguns ficam sem lastro. Some o chip sem peça — e some
       a LINHA inteira quando sobra um chip só, porque filtro com uma opção não
       muda o resultado: ele só repete o que a grade já mostra. */
    function podaChips() {
      if (!chips) return;
      var campo = { perm: 'permanencia', cat: 'cat', flor: 'flor' };
      $$('[data-filtro]', chips).forEach(function (b) {
        var c = campo[b.getAttribute('data-filtro')];
        var v = b.getAttribute('data-valor');
        var tem = PECAS.some(function (p) { return p[c] === v; });
        /* O chip de CATEGORIA a caminho fica, porque ele leva à moldura, que é
           uma resposta. Os chips de FLOR e de PERMANÊNCIA sem peça continuam
           saindo: eles descrevem o que as peças SÃO, e sem peça nenhuma não há
           moldura que os justifique — "rosa" só volta quando existir uma rosa. */
        if (!tem && c === 'cat') {
          var cat = CATEGORIAS.filter(function (x) { return x.id === v; })[0];
          if (cat && cat.aCaminho) return;
        }
        if (!tem) b.remove();
      });
      $$('.filtros__linha', chips).forEach(function (linha) {
        if ($$('[data-filtro]', linha).length < 2) linha.remove();
      });
      if (!$$('[data-filtro]', chips).length) chips.remove();
    }

    /* Acentos fora e caixa baixa: quem digita "orquidea" no celular, sem o
       acento, tem de achar "Mini orquídea lilás". `normalize('NFD')`
       separa a letra do sinal e o replace joga o sinal fora — sem tabela de
       substituição para manter. */
    function chave(t) {
      return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    }

    function filtra() {
      /* A busca casa contra nome, resumo E espécie. Só o nome não bastaria:
         "girassol" está no nome de uma peça mas em `flor` de outra, e quem
         procura "rosa" espera as duas. Cada palavra digitada precisa aparecer
         em algum desses campos — assim "buquê rosa" filtra de verdade em vez
         de virar uma frase que não casa com nada. */
      var termos = chave(estado.busca).split(/\s+/).filter(Boolean);
      return PECAS.filter(function (p) {
        if (estado.cat && p.cat !== estado.cat) return false;
        if (estado.perm && p.permanencia !== estado.perm) return false;
        if (estado.flor && p.flor !== estado.flor) return false;
        if (termos.length) {
          var alvo = chave(p.nome + ' ' + (p.resumo || '') + ' ' + (p.flor || ''));
          for (var i = 0; i < termos.length; i++) {
            if (alvo.indexOf(termos[i]) === -1) return false;
          }
        }
        return true;
      });
    }

    /* A seção "Sobre" só existe quando há UMA categoria escolhida e a busca
       está vazia. Sem esse par a pergunta não tem sujeito: "sobre a loja
       inteira" juntaria cuidado de flor de corte com cuidado de planta viva, e
       "sobre a busca por rosa" não é categoria nenhuma.

       `.visivel` entra à mão, sem esperar o IntersectionObserver: quem clica
       num chip acende a seção com a página já parada, e o observador foi
       montado quando ela ainda estava `hidden`. Sem isto o bloco nasceria
       deslocado 14px para baixo, que é o estado de repouso da revelação. */
    /* UM CAMINHO SO PARA FOTO QUE EXISTE E PARA FOTO QUE AINDA NAO EXISTE.
       Sem `arq`, devolve o molde — a caixa com a medida certa e o briefing
       dentro (ver o bloco MOLDE DE IMAGEM no <style> da /collections/all). Com `arq`,
       devolve o `<img>` com a MESMA classe de posicao e o MESMO `--ar`.
       Trocar molde por foto vira, entao, acrescentar duas chaves ao dado — e
       nao editar markup em tres lugares e esquecer um. */
    function molde(d, tira) {
      if (!d) return '';
      var ar = 'style="--ar:' + (d.ar || (tira ? '4/5' : '3/2')) + '"';
      if (d.arq) {
        return '<img src="' + esc(d.arq) + '" alt="' + esc(d.alt || '') + '" ' + ar +
               ' loading="lazy" decoding="async">';
      }
      var razao = String(d.ar || (tira ? '4/5' : '3/2')).replace('/', ':');
      if (tira) {
        /* Pequena demais para prosa: o briefing fica no `title` (hover) e no
           `.so-leitor` (leitor de tela), mas continua no DOM para quem for
           produzir a foto ler direto da pagina. */
        return '<figure class="molde molde--tira" ' + ar +
                 ' title="Foto a produzir — ' + esc(d.brief) + '">' +
                 '<figcaption class="so-leitor">Foto a produzir: ' + esc(d.brief) + '</figcaption>' +
               '</figure>';
      }
      return '<figure class="molde" ' + ar + '>' +
               '<figcaption class="molde__txt">' +
                 '<span class="rotulo">Foto a produzir</span>' +
                 '<span class="molde__brief">' + esc(d.brief) + '</span>' +
                 '<span class="molde__meta">Master ' + razao + ' \u00B7 ainda não fotografada</span>' +
               '</figcaption>' +
             '</figure>';
    }

    function pintaSobre() {
      if (!sobre) return;
      /* O editorial da categoria pressupõe peça na grade: ele responde "o que é
         essa peça e o que eu faço com ela". Com a categoria vazia — alcancável
         digitando `?cat=buques` na barra, mesmo com o link fora do menu — ele
         ficaria falando de cuidado de uma coisa que a loja não vende hoje. */
      var temPeca = estado.cat && contaDaCategoria(estado.cat) > 0;
      var d = (!estado.busca && temPeca) ? SOBRE_CATEGORIA[estado.cat] : null;
      if (!d) { sobre.hidden = true; return; }

      var poe = function (sel, texto) {
        var el = $(sel, sobre);
        if (el) el.textContent = texto;
      };
      poe('[data-sc-rotulo]', d.rotulo);
      poe('[data-sc-titulo]', d.titulo);
      poe('[data-sc-olho]', d.olho);
      poe('[data-sc-nota]', d.nota);

      var corpo = $('[data-sc-corpo]', sobre);
      if (corpo) {
        corpo.innerHTML = d.corpo.map(function (t) { return '<p>' + t + '</p>'; }).join('');
      }
      var foto = $('[data-sc-foto]', sobre);
      if (foto) foto.innerHTML = molde(d.foto, false);

      var cuidado = $('[data-sc-cuidado]', sobre);
      if (cuidado) {
        cuidado.innerHTML = d.cuidado.map(function (l) {
          /* O terceiro item da linha e o briefing da tira. Quando a foto
             existir, ele vira `{ ar, brief, arq, alt }` — string continua
             valendo, e e o formato enquanto so ha briefing. */
          var f = l[2];
          if (typeof f === 'string') f = { ar: '4/5', brief: f };
          return '<div class="cuidado__l">' +
                   '<dt class="cuidado__t">' + l[0] + '</dt>' +
                   '<dd class="cuidado__d">' + l[1] + '</dd>' +
                   '<dd class="cuidado__m">' + molde(f, true) + '</dd>' +
                 '</div>';
        }).join('');
      }
      sobre.hidden = false;
      $$('[data-revela]', sobre).forEach(function (el) { el.classList.add('visivel'); });
    }

    function pinta() {
      var lista = filtra();
      /* Com busca ativa o título repete o que a pessoa digitou. Ela precisa ver
         que a grade está respondendo à busca dela, e não à categoria — senão um
         resultado curto parece catálogo pequeno em vez de recorte. */
      if (titulo) {
        titulo.textContent = estado.busca
          ? 'Busca por “' + estado.busca + '”'
          : nomeCat(estado.cat);
      }
      /* A MOLDURA VEM ANTES DO ESTADO VAZIO, e a ordem é o conteúdo: "nada com
         esse recorte hoje" responde a um filtro que não casou e manda tirar um
         filtro. Não é o que acontece aqui — a categoria existe, a casa vende, e a
         peça ainda não entrou. Trocar uma mensagem pela outra faria a loja parecer
         sem estoque em vez de em montagem. */
      var moldura = molduraDaCategoria(estado);
      if (conta) {
        /* "0 peças" ao lado de uma moldura seria o mesmo desencontro, em número. */
        conta.textContent = moldura ? 'a caminho'
          : lista.length === 1 ? '1 peça'
          : lista.length + ' peças';
      }
      grade.innerHTML = lista.length
        ? lista.map(cartao).join('')
        : moldura ||
          '<div class="vazio" style="grid-column:1/-1"><b>Nada com esse recorte hoje</b>' +
          '<p>' + (estado.busca
            /* A lista de flores sai do CATÁLOGO e não de uma frase fixa: ela
               dizia "rosa, orquídea, girassol" e, quando as peças de rosa e
               girassol saíram, a única tela que socorre quem não achou nada
               passou a sugerir duas buscas que dão zero. */
            ? 'O que a casa monta muda com o que chegou bom na manhã. Tente o nome da flor — ' +
              floresDoCatalogo() + ' — ou fale com a loja.'
            : 'O que a casa monta muda com o que chegou bom na manhã. Vale tirar um filtro.') +
          '</p></div>';

      $$('[data-filtro]', chips || document).forEach(function (b) {
        var campo = b.getAttribute('data-filtro');
        var valor = b.getAttribute('data-valor');
        if (estado[campo] === valor) b.setAttribute('aria-pressed', 'true');
        else b.setAttribute('aria-pressed', 'false');
      });

      pintaSobre();
    }

    podaChips();

    if (chips) {
      chips.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-filtro]');
        if (!b) return;
        var campo = b.getAttribute('data-filtro');
        var valor = b.getAttribute('data-valor');
        estado[campo] = (estado[campo] === valor) ? '' : valor;
        pinta();
      });
    }

    pinta();
  }


  /* O "G" do Google nas cores dele. É a única coisa fora da paleta em todo o
     site, e é de propósito: aqui ele não é decoração, é ATRIBUIÇÃO — diz de
     quem é a nota. Recolorir a marca de terceiro para caber na paleta seria
     descaracterizá-la, que é justamente o que o nosso próprio manual proíbe
     fazerem com a marca da casa. Fica pequeno (18px) e sozinho. */
  var LOGO_GOOGLE =
    '<svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">' +
      '<path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-2.7-.4-4H24v7.3h12.1c-.2 1.9-1.6 4.8-4.5 6.8l-.1.3 6.5 5 .5.1c4.1-3.8 6.6-9.5 6.6-15.5Z"/>' +
      '<path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.3l-6.9-5.4c-1.8 1.3-4.3 2.2-7.6 2.2-5.8 0-10.7-3.8-12.5-9.1l-.3 0-6.8 5.2-.1.3C7.9 41 15.4 46 24 46Z"/>' +
      '<path fill="#FBBC05" d="M11.5 28.4c-.5-1.4-.7-2.9-.7-4.4s.3-3 .7-4.4v-.3l-6.9-5.3-.2.1A22 22 0 0 0 2 24c0 3.5.9 6.9 2.4 9.9l7.1-5.5Z"/>' +
      '<path fill="#EA4335" d="M24 10.1c4.1 0 6.9 1.8 8.5 3.3l6.2-6C34.9 3.9 29.9 2 24 2 15.4 2 7.9 7 4.4 14.1l7.1 5.5c1.8-5.3 6.7-9.5 12.5-9.5Z"/>' +
    '</svg>';

  /* As cinco estrelas com recorte EXATO. 4,6 não é "quatro e meia": a régua é
     linear sobre a fita inteira, então a máscara corta em
     4 estrelas + 4 vãos + 0,6 da quinta. Arredondar para meia estrela mostraria
     4,5 ao lado de um número que diz 4,6 — símbolo e número discordando na
     mesma linha é o tipo de detalhe que derruba a credibilidade da prova.
     A ESTRELA MUDOU DE COR EM 13/08/2026, e isto inverte a decisão anterior.
     Ela era Verde Casa, com a justificativa de que "o selo é um componente da
     Casa Flores citando o Google, não um widget do Google embutido". O pedido
     do cliente derrubou o argumento, e ele tem razão: o valor deste bloco é
     parecer OFICIAL. Estrela verde lê como "nós redesenhamos o Google" — a casa
     estilizando a prova de terceiro, que é justamente o que tira a força dela.
     Ouro #FBBC04 é a cor real da estrela do Google, da mesma família do "G"
     multicolorido que este componente sempre usou.

     CONTRASTE: ouro sobre branco mede 1,71:1, abaixo dos 3:1 que a WCAG 1.4.11
     pede de gráfico com significado. Passa mesmo assim, e por regra, não por
     tolerância: a informação está inteira em TEXTO ao lado ("4,6" e "90
     avaliações · 73 de cinco estrelas"), o SVG é aria-hidden e o link carrega
     aria-label completo. 1.4.11 dispensa o gráfico cuja informação já está
     disponível em texto. Se um dia o número sair do selo, a estrela deixa de
     ser dispensada e esta cor reprova. */
  function estrelas(nota) {
    var v = parseFloat(String(nota).replace(',', '.'));
    var L = 20, VAO = 3, N = 5;
    var largura = N * L + (N - 1) * VAO;
    var cheias = Math.floor(v);
    var resto = v - cheias;
    var corte = cheias * (L + VAO) + resto * L;
    var d = 'M10 1.4l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L1.5 7.6l5.9-.8Z';
    var estrela = function (i, fill) {
      return '<path transform="translate(' + (i * (L + VAO)) + ')" d="' + d + '" fill="' + fill + '"/>';
    };
    var vazias = '', cheiasSVG = '', i;
    for (i = 0; i < N; i++) { vazias += estrela(i, '#DADCE0'); cheiasSVG += estrela(i, '#FBBC04'); }
    var id = 'corte-nota';
    return '<svg class="selo-nota__estrelas" width="' + largura + '" height="' + L +
             '" viewBox="0 0 ' + largura + ' ' + L + '" role="img" aria-hidden="true"' +
             ' focusable="false">' +
             '<defs><clipPath id="' + id + '"><rect width="' + corte.toFixed(2) +
               '" height="' + L + '"/></clipPath></defs>' +
             vazias +
             '<g clip-path="url(#' + id + ')">' + cheiasSVG + '</g>' +
           '</svg>';
  }

  /* LER MAIS — decide, depoimento a depoimento, se o botão faz sentido.

     O texto inteiro já está no DOM: o clamp é visual e o botão só o solta.
     Nada foi cortado do dado, então a regra do §2 continua valendo — "texto
     LITERAL, se precisar cortar, não usa" governa a SELEÇÃO do depoimento, não
     quanto dele aparece de imediato. O que está publicado é a íntegra.

     `scrollHeight > clientHeight` é a única pergunta: o texto transborda as
     quatro linhas? Se não transborda, o depoimento perde a classe de corte E o
     botão — porque botão que abre para revelar nada é ruído, e a avaliação
     curta da Ana Cristina cabe inteira.

     É IDEMPOTENTE de propósito: roda uma vez no pintar e outra quando as fontes
     assentam. A segunda passada precisa reavaliar sem empilhar um segundo
     ouvinte de clique, daí o `data-ligado`. E ela só volta a cortar quem está
     fechado — se o leitor já abriu um depoimento, a chegada da fonte não pode
     fechá-lo na cara dele. */
  function ligaLerMais(grade) {
    $$('.dep', grade).forEach(function (fig) {
      var txt = fig.querySelector('.dep__t');
      var btn = fig.querySelector('.dep__mais');
      if (!txt || !btn) return;

      var aberto = btn.getAttribute('aria-expanded') === 'true';
      if (!aberto) fig.classList.add('dep--corta');

      /* Só transborda quem está cortado; medir aberto responde sempre "não".
         O botão é ESCONDIDO, não removido do DOM: uma medição feita cedo demais
         (subárvore ainda `hidden`, fonte ainda não assentada) devolve 0×0 e
         concluiria "cabe" para todo mundo. Removendo, o erro seria definitivo —
         não haveria botão para a segunda passada corrigir. Escondendo, ele
         volta. */
      var cabe = !aberto && txt.scrollHeight <= txt.clientHeight + 1;
      btn.hidden = cabe;
      if (cabe) { fig.classList.remove('dep--corta'); return; }

      if (btn.getAttribute('data-ligado')) return;
      btn.setAttribute('data-ligado', '1');
      btn.addEventListener('click', function () {
        var abre = fig.classList.contains('dep--corta');
        fig.classList.toggle('dep--corta', !abre);
        btn.setAttribute('aria-expanded', abre ? 'true' : 'false');
        btn.textContent = abre ? 'Ler menos' : 'Ler mais';
      });
    });
  }

  /* A seção nasce `hidden` no HTML e só é revelada aqui. Se um dia alguém
     esvaziar AVALIACOES, ela some sozinha em vez de publicar uma moldura vazia
     com aspas de enfeite. */
  function pintaAvaliacoes() {
    var secao = $('[data-avaliacoes-secao]');
    if (!secao) return;
    if (!AVALIACOES.length) return;

    var nota = $('[data-nota-geral]');
    if (nota && AVALIACOES_GOOGLE.nota) {
      var g = AVALIACOES_GOOGLE;
      nota.innerHTML =
        '<a class="selo-nota" href="' + esc(g.fonte) + '" target="_blank" rel="noopener"' +
          ' aria-label="Casa Flores tem nota ' + esc(g.nota) + ' de 5 em ' + g.quantidade +
            ' avaliações no Google. Abre a ficha do Google numa nova aba.">' +
          '<span class="selo-nota__fonte">' + LOGO_GOOGLE + '<span>Google</span></span>' +
          '<span class="selo-nota__dados">' +
            '<span class="selo-nota__linha">' +
              '<span class="selo-nota__n">' + esc(g.nota) + '</span>' +
              estrelas(g.nota) +
            '</span>' +
            '<span class="selo-nota__q">' + g.quantidade + ' avaliações · ' +
              g.cincoEstrelas + ' de cinco estrelas</span>' +
          '</span>' +
          '<svg class="selo-nota__seta" width="15" height="15" viewBox="0 0 20 20" fill="none"' +
            ' stroke="currentColor" stroke-width="1.6" stroke-linecap="round"' +
            ' stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 14L14 6M7.4 6H14v6.6"/></svg>' +
        '</a>';
      nota.removeAttribute('hidden');
    }

    var grade = $('[data-avaliacoes]');
    if (grade) {
      grade.innerHTML = AVALIACOES.map(function (a, i) {
        var idT = 'dep-t-' + i;
        return '' +
          '<figure class="dep dep--corta">' +
            '<blockquote class="dep__t" id="' + idT + '">' +
              esc(a.texto).split('\n').join('<br>') + '</blockquote>' +
            /* O botão nasce no HTML e é REMOVIDO depois, onde o texto couber
               inteiro — em vez de nascer ausente e ser inserido. Assim, se o JS
               de medição falhar, sobra um botão que funciona; o contrário
               deixaria o texto cortado sem nenhuma forma de abrir. */
            '<button class="dep__mais" type="button" aria-expanded="false"' +
              ' aria-controls="' + idT + '">Ler mais</button>' +
            '<figcaption class="dep__a">' +
              '<span class="dep__n">' + esc(a.autor) + '</span>' +
              /* POR QUE UMA DAS TRÊS NÃO TEM MÊS, e por que isso não é falha de
                 coleta. O Google publica a data em RELATIVO e nada mais. "7 meses
                 atrás" lido em 13/08/2026 resolve para um mês exato — janeiro de
                 2026. "Um ano atrás" não resolve: é um balde arredondado que cobre
                 uma faixa larga, então o mês da Marianna Maldonado simplesmente
                 não existe como dado público. Data absoluta de avaliação só é
                 visível para o DONO da ficha, dentro do Google Business Profile
                 Manager. Enquanto o Gilberto não abrir isso, "2025" é a precisão
                 honesta — e escrever um mês aqui seria inventar.
                 O `relativo` (já coletado e conferido para as três, e até agora
                 sem uso) entra no `title`: quem passar o mouse lê a forma literal
                 do Google e a diferença de precisão se explica sozinha. */
              '<span class="dep__q"' +
                (a.relativo ? ' title="No Google: ' + esc(a.relativo) +
                  ' (lido em ' + esc(AVALIACOES_GOOGLE.lidoEm) + ')"' : '') + '>' +
                esc(a.quando) +
                (a.guia ? ' · ' + esc(a.guia) : '') + '</span>' +
            '</figcaption>' +
          '</figure>';
      }).join('');
    }

    var fonte = $('[data-avaliacoes-fonte]');
    if (fonte) {
      /* A LINHA ENCURTOU EM 14/08/2026, e o que ela perdeu foi explicação, não
         ressalva. A versão anterior gastava uma oração inteira ensinando como o
         Google mostra data ("mostra em relativo — as datas acima são a
         conversão") para chegar em "são aproximadas", que é a única parte que o
         leitor precisa. A mecânica continua no site: o `title` de cada data traz
         a forma literal do Google e a data da leitura, que é onde ela cabe.
         O que NÃO podia sair, e não saiu: de onde vêm (Google), que são
         literais, e quantas estão à vista contra quantas existem.
         Os dois números saem dos dados, nunca escritos à mão: trocar a lista de
         depoimentos reescreve a frase sozinha.
         A BASE É 90, o total da ficha — e não um recorte das que têm texto
         escrito. É o único número que passou pela conferência de segunda
         leitura do doc 50 e o mesmo que o selo da nota publica logo acima, então
         a seção inteira fala de uma base só.

         O LINK SAIU DAQUI EM 14/08/2026, e a regra 3 continua de pé — ela é
         cumprida por outro elemento. O selo da nota, no alto da seção, É um
         link inteiro para esta mesma URL (`AVALIACOES_GOOGLE.fonte`), com
         aria-label dizendo que abre a ficha do Google. Dois links para o mesmo
         destino a uma tela de distância é repetição, e ela custa: para quem
         navega por lista de links do leitor de tela, o mesmo endereço aparece
         duas vezes com rótulos diferentes.
         O QUE ISSO PASSA A EXIGIR: se um dia o selo deixar de ser link — ou a
         nota sair da seção —, o link volta para cá. A saída para as 90 não pode
         sumir da seção; ela é o que separa prova social de propaganda. */
      fonte.innerHTML =
        'Avaliações publicadas no Google, transcritas na íntegra. Mostrando ' +
        AVALIACOES.length + ' das ' + AVALIACOES_GOOGLE.quantidade +
        ' — as datas são aproximadas.';
      fonte.removeAttribute('hidden');
    }

    secao.removeAttribute('hidden');

    /* A MEDIÇÃO DO "LER MAIS" VEM DEPOIS DO `removeAttribute('hidden')`, e essa
       ordem é o conserto de um bug real: rodando antes, a seção ainda está
       `hidden`, todo elemento dentro dela mede 0×0, `scrollHeight` empata com
       `clientHeight`, a função conclui que os três depoimentos cabem e os três
       botões somem. Medida de layout dentro de subárvore escondida não é
       imprecisa — é zero.

       E DEPOIS DA FONTE também. Quantas linhas o texto ocupa depende de quem o
       desenha: medir com a fonte de sistema e a Work Sans chegar depois faz o
       botão sobrar num depoimento que passou a caber, ou faltar em um que passou
       a transbordar. É a mesma correção que a faixa de garantias já fazia. */
    var gradeDeps = $('[data-avaliacoes]');
    if (gradeDeps) {
      ligaLerMais(gradeDeps);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { ligaLerMais(gradeDeps); });
      }
    }
  }



  /* ------------------------------------------------------- a esteira de logos

     Duas armadilhas herdadas do projeto da Edelweiss, e as duas custam caro
     para achar depois:

     · O vão é PADDING no item, nunca `gap` no trilho. Com `gap`, sobra um vão
       só entre as duas metades e a emenda do laço vira um solavanco a cada
       volta.
     · `data-revela` fica no INVÓLUCRO, nunca no trilho: os dois animam
       `transform` e brigariam entre si.

     A esteira anda da esquerda para a direita, no mesmo sentido da faixa de
     garantias — duas esteiras na mesma página andando em sentidos opostos
     leem como defeito, não como ritmo. */
  /* SEÇÃO DE VÍDEOS. O cartão é só a capa (imagem) + o play; o vídeo toca na
     TELA CHEIA (telaDeVideo, logo abaixo), que só busca o arquivo quando abre.
     Desde 28/09/2026 — antes tocava dentro do próprio cartão. */
  function pintaVideos() {
    var secao = $('[data-videos-secao]');
    var lista = $('[data-videos]');
    if (!secao || !lista) return;
    /* Enquanto nenhum vídeo tiver arquivo, a seção mostra VIDEOS_PREVIA (fotos da
       casa), a pedido do Erik em 28/09/2026: ele quis ver a seção no ar antes de
       mandar os vídeos. O play desses cartões é só desenho (<span>), não botão:
       um botão que não toca nada é defeito. */
    /* Os vídeos com arquivo vêm primeiro; as fotos da prévia completam a fileira
       até 5 enquanto o resto não chega, sem repetir título. Com 5 vídeos, a
       prévia some sozinha. ?videos=previa força só as fotos. */
    var comArquivo = VIDEOS.filter(function (v) { return v.arq; });
    var soPrevia = /(?:\?|&)videos=previa\b/.test(location.search);
    var itens = soPrevia ? VIDEOS_PREVIA : comArquivo.concat(
      VIDEOS_PREVIA.filter(function (f) {
        return !comArquivo.some(function (v) { return v.titulo === f.titulo; });
      })
    ).slice(0, Math.max(5, comArquivo.length));
    if (!itens.length) return;

    var play = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">' +
               '<path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
    lista.innerHTML = itens.map(function (v, i) {
      var n = (i + 1 < 10 ? '0' : '') + (i + 1);
      return '<li class="video">' +
        '<div class="video__quadro">' +
          '<img class="video__midia" src="' + esc(v.poster || '') + '" alt="" loading="lazy" decoding="async">' +
          (v.arq
            ? '<button class="video__play" type="button" data-video-abre="' + comArquivo.indexOf(v) + '"' +
                ' aria-haspopup="dialog" aria-label="Assistir: ' + esc(v.titulo) + '">' + play + '</button>'
            : '<span class="video__play video__play--desenho" aria-hidden="true">' + play + '</span>') +
        '</div>' +
        '<p class="video__legenda"><span class="video__num">' + n + '</span>' +
          '<span class="video__titulo">' + esc(v.titulo) + '</span></p>' +
      '</li>';
    }).join('');
    secao.hidden = false;

    lista.addEventListener('click', function (ev) {
      var bt = ev.target.closest('[data-video-abre]');
      if (!bt) return;
      telaDeVideo(comArquivo, parseInt(bt.getAttribute('data-video-abre'), 10), bt);
    });
  }

  /* TELA CHEIA DE VÍDEO (28/09/2026, pedido do Erik: "abra uma página grande",
     no formato da Reserva Floral). Fundo escuro, o vídeo vertical na altura
     da tela, barras de progresso no topo (uma por vídeo), contador, fechar,
     título grande embaixo à esquerda e botão de som só quando o vídeo TEM som
     (`som: false` esconde — o 1º vídeo é mudo e um "desativar som" ali mentiria).
     Terminou um, entra o próximo; no último, para. Navega por ← →, por toque
     no terço esquerdo/direito do vídeo e pelas setas; Esc e o X fecham e
     devolvem o foco ao botão que abriu. A página de trás não rola enquanto ela
     está aberta. Só entram vídeos com arquivo: as fotos da prévia não abrem. */
  var telaVideo = null;
  function telaDeVideo(itens, ini, origem) {
    if (!itens.length) return;
    if (!telaVideo) {
      var t = document.createElement('div');
      t.className = 'tela-video';
      t.setAttribute('role', 'dialog');
      t.setAttribute('aria-modal', 'true');
      t.setAttribute('aria-labelledby', 'tela-video-titulo');
      t.hidden = true;
      t.innerHTML =
        '<div class="tela-video__topo">' +
          '<div class="tela-video__barras" data-tv-barras></div>' +
          '<span class="tela-video__conta" data-tv-conta></span>' +
          '<button class="tela-video__fechar" type="button" data-tv-fechar aria-label="Fechar o vídeo">' +
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="tela-video__palco">' +
          '<video class="tela-video__midia" data-tv-video playsinline preload="auto"></video>' +
          '<button class="tela-video__zona tela-video__zona--ant" type="button" data-tv-ant aria-label="Vídeo anterior"></button>' +
          '<button class="tela-video__zona tela-video__zona--prox" type="button" data-tv-prox aria-label="Próximo vídeo"></button>' +
        '</div>' +
        '<button class="tela-video__seta tela-video__seta--ant" type="button" data-tv-ant aria-label="Vídeo anterior">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button class="tela-video__seta tela-video__seta--prox" type="button" data-tv-prox aria-label="Próximo vídeo">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<div class="tela-video__pe">' +
          '<h2 class="tela-video__titulo" id="tela-video-titulo" data-tv-titulo></h2>' +
          '<button class="tela-video__som" type="button" data-tv-som hidden>' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9a4 4 0 0 1 0 6" data-tv-onda/></svg>' +
            '<span data-tv-som-txt>Desativar som</span></button>' +
        '</div>';
      document.body.appendChild(t);
      telaVideo = { el: t, itens: [], i: 0, origem: null, mudo: false,
        video: t.querySelector('[data-tv-video]') };
      var tv = telaVideo;

      var fecha = function () {
        tv.video.pause(); tv.video.removeAttribute('src'); tv.video.load();
        t.hidden = true;
        document.documentElement.classList.remove('tela-video-aberta');
        if (tv.origem && tv.origem.focus) tv.origem.focus();
      };
      tv.fecha = fecha;
      t.querySelector('[data-tv-fechar]').addEventListener('click', fecha);
      Array.prototype.forEach.call(t.querySelectorAll('[data-tv-ant]'), function (b) {
        b.addEventListener('click', function () { if (tv.i > 0) tv.vai(tv.i - 1); else { tv.video.currentTime = 0; tv.video.play(); } });
      });
      Array.prototype.forEach.call(t.querySelectorAll('[data-tv-prox]'), function (b) {
        b.addEventListener('click', function () { if (tv.i < tv.itens.length - 1) tv.vai(tv.i + 1); });
      });
      t.querySelector('[data-tv-som]').addEventListener('click', function () {
        tv.mudo = !tv.mudo; tv.video.muted = tv.mudo; tv.pintaSom();
      });
      tv.pintaSom = function () {
        t.querySelector('[data-tv-som-txt]').textContent = tv.mudo ? 'Ativar som' : 'Desativar som';
        t.querySelector('[data-tv-onda]').style.display = tv.mudo ? 'none' : '';
      };
      tv.video.addEventListener('timeupdate', function () {
        var d = tv.video.duration;
        var barra = t.querySelectorAll('.tela-video__barra i')[tv.i];
        if (barra && d) barra.style.transform = 'scaleX(' + Math.min(1, tv.video.currentTime / d) + ')';
      });
      tv.video.addEventListener('ended', function () {
        if (tv.i < tv.itens.length - 1) tv.vai(tv.i + 1);
      });
      /* clique no vídeo (fora das zonas) pausa / retoma */
      tv.video.addEventListener('click', function () { if (tv.video.paused) tv.video.play(); else tv.video.pause(); });
      t.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') { ev.preventDefault(); fecha(); return; }
        if (ev.key === 'ArrowRight') { ev.preventDefault(); if (tv.i < tv.itens.length - 1) tv.vai(tv.i + 1); return; }
        if (ev.key === 'ArrowLeft') { ev.preventDefault(); if (tv.i > 0) tv.vai(tv.i - 1); return; }
        if (ev.key === 'Tab') {                         /* o foco não sai da tela */
          var f = Array.prototype.filter.call(t.querySelectorAll('button'), function (b) { return !b.hidden && b.offsetParent !== null; });
          if (!f.length) return;
          var ult = f[f.length - 1], pri = f[0];
          if (ev.shiftKey && document.activeElement === pri) { ev.preventDefault(); ult.focus(); }
          else if (!ev.shiftKey && document.activeElement === ult) { ev.preventDefault(); pri.focus(); }
        }
      });
      tv.vai = function (n) {
        tv.i = n;
        var v = tv.itens[n];
        var barras = t.querySelectorAll('.tela-video__barra i');
        Array.prototype.forEach.call(barras, function (b, k) { b.style.transform = 'scaleX(' + (k < n ? 1 : 0) + ')'; });
        var dois = function (x) { return (x < 10 ? '0' : '') + x; };
        t.querySelector('[data-tv-conta]').textContent = dois(n + 1) + ' / ' + dois(tv.itens.length);
        t.querySelector('[data-tv-titulo]').textContent = v.titulo;
        var som = t.querySelector('[data-tv-som]');
        som.hidden = v.som === false;
        tv.video.muted = v.som === false ? true : tv.mudo;
        tv.pintaSom();
        if (v.poster) tv.video.poster = v.poster; else tv.video.removeAttribute('poster');
        tv.video.src = v.arq;
        var p = tv.video.play(); if (p && p.catch) p.catch(function () {});
        var uma = tv.itens.length < 2;
        Array.prototype.forEach.call(t.querySelectorAll('[data-tv-ant],[data-tv-prox]'), function (b) { b.hidden = uma; });
        if (!uma) {
          Array.prototype.forEach.call(t.querySelectorAll('.tela-video__seta--ant'), function (b) { b.disabled = n === 0; });
          Array.prototype.forEach.call(t.querySelectorAll('.tela-video__seta--prox'), function (b) { b.disabled = n === tv.itens.length - 1; });
        }
      };
    }
    var tv = telaVideo;
    tv.itens = itens; tv.origem = origem || null;
    tv.el.querySelector('[data-tv-barras]').innerHTML = itens.map(function () {
      return '<span class="tela-video__barra"><i></i></span>';
    }).join('');
    tv.el.hidden = false;
    document.documentElement.classList.add('tela-video-aberta');
    tv.vai(Math.max(0, Math.min(ini || 0, itens.length - 1)));
    tv.el.querySelector('[data-tv-fechar]').focus();
  }

  function pintaClientes() {
    var secao = $('[data-clientes-secao]');
    if (!secao) return;
    if (!CLIENTES.length) return;   /* sem nome confirmado, a seção não existe */

    var trilho = $('[data-clientes]');
    if (!trilho) return;

    /* A medida vai como variável CSS, e não em `max-height` na folha. É a
       diferença entre o mural funcionar e não funcionar: um `max-height` igual
       para todas achata a régua ótica de volta — todas as logos passariam a ter
       a mesma altura, que é justamente o que a régua existe para evitar.
       Com `--w`/`--h` por logo, cada uma guarda a proporção que lhe coube, e
       `--esc` encolhe o conjunto inteiro no celular sem desfazer a relação. */
    var um = function (c, clone) {
      return '<li class="cliente' + (c.classe ? ' ' + esc(c.classe) : '') + (clone ? ' cliente--clone' : '') + '"' +
             ' style="--w:' + c.w + ';--h:' + c.h + '"' +
             (clone ? ' aria-hidden="true"' : '') + '>' +
               /* `original/` = a logo NA COR DA PRÓPRIA MARCA. A pasta de cima
                  guarda a versão em duotone Verde Casa, que o processa_logos.py
                  continua gerando — trocar as duas é mudar este caminho e mais
                  nada, porque as duas saídas têm exatamente a mesma medida. */
               '<img src="//casaflores.com.br/cdn/shop/t/2/assets/casaflores-clientes__original__' + esc(c.arq) + '.' + esc(c.ext || 'png') + (c.v ? '?v=' + encodeURIComponent(c.v) : '') + '"' +
                 ' width="' + c.w + '" height="' + c.h + '"' +
                 ' alt="' + (clone ? '' : esc(c.alt || c.nome)) + '"' +
                 ' loading="lazy" decoding="async">' +
             '</li>';
    };

    /* Uma cópia é o conteúdo; a segunda existe só para tapar a tela enquanto o
       trilho volta ao começo, e por isso sai da árvore de acessibilidade —
       senão o leitor anuncia a lista inteira duas vezes. */
    trilho.innerHTML =
      CLIENTES.map(function (c) { return um(c, false); }).join('') +
      CLIENTES.map(function (c) { return um(c, true); }).join('');

    secao.removeAttribute('hidden');
  }

  /* ------------------------------------------------------------ o cabeçalho */

  function cabecalho() {
    var h = $('.header');
    if (!h) return;
    /* A home tem hero de foto: o cabeçalho começa transparente sobre a chapa
       Verde Casa e vira sólido ao sair dela. Página sem hero já nasce sólida. */
    var temHero = !!$('.hero');
    if (!temHero) { h.setAttribute('data-state', 'solid'); return; }

    var marca = function () {
      var y = window.scrollY || window.pageYOffset;
      h.setAttribute('data-state', y > 40 ? 'solid' : 'transparent');
    };
    marca();
    window.addEventListener('scroll', marca, { passive: true });
  }

  /* ------------------------------------------------------------- revelação */

  function revelacao() {
    var alvos = $$('[data-revela]');
    if (!alvos.length) return;
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (el) { el.classList.add('visivel'); });
      return;
    }
    var obs = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visivel'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    alvos.forEach(function (el) { obs.observe(el); });
  }

  /* ------------------------------------------------------- o filme do hero */

  /* O `<video>` do hero nasce SEM `src`, e e esta funcao que decide se ele
     ganha um. Nao e enfeite de progressive enhancement: e a unica forma de o
     arquivo nao ser baixado por quem nao vai ve-lo.

     Com `autoplay` escrito no HTML, o navegador busca o arquivo antes de
     qualquer JS rodar — inclusive para quem pediu menos movimento no sistema,
     que e justamente quem nao vai ver o filme. Sao 4,2 MB. Entao o atributo
     nao existe; quem liga e aqui.

     TRES PORTOES, nesta ordem:
     1. `prefers-reduced-motion` — pedido explicito do sistema operacional.
        O resto do site ja o respeita (ha tres blocos dele no styles.css);
        um filme de 20 s em laco seria o maior movimento da pagina.
     2. `saveData` — o visitante ligou economia de dados no navegador.
     3. `effectiveType` 2g/3g — conexao lenta. Nesses tres casos fica o
        `poster`, que e o primeiro quadro do filme: a pagina nao fica vazia
        nem diferente, so parada.

     A VERSAO VERTICAL E ESCOLHIDA AQUI, e nao por `<source media>`, porque
     `media` em `<source>` de VIDEO nao e implementado (so vale dentro de
     `<picture>`). Escrever `<source media="(max-width:760px)">` num video
     compila, nao da erro nenhum e simplesmente nao troca de arquivo — o
     celular baixaria os 4,2 MB da paisagem. O corte e o mesmo 760px do CSS.

     A escolha e feita UMA vez, na carga. Girar o telefone depois nao troca o
     arquivo: trocar o `src` de um video em execucao reinicia o laco, e um
     salto de imagem custa mais do que o recorte errado por meio minuto.

     `play()` devolve promessa, e ela REJEITA quando a politica de autoplay do
     navegador barra (acontece em Safari com economia de bateria). Sem o
     `catch` isso vira "Unhandled promise rejection" no console de quem for
     depurar outra coisa. Barrado, fica o poster — que e o quadro 1 do filme. */
  function filmeDoHero() {
    var v = $('.hero__video');
    if (!v || !v.dataset.filme) return;

    var conexao = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var parado = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)
      || (conexao && (conexao.saveData === true
                      || /(^|-)2g$/.test(conexao.effectiveType || '')
                      || conexao.effectiveType === 'slow-2g'));
    if (parado) return;

    var vertical = window.matchMedia && matchMedia('(max-width: 760px)').matches;
    if (vertical && v.dataset.posterVertical) v.poster = v.dataset.posterVertical;
    v.src = (vertical && v.dataset.filmeVertical) ? v.dataset.filmeVertical : v.dataset.filme;
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* barrado pela politica: fica o poster */ });
  }

  /* ---------------------------------------------------------- o checkout */

  /* O PEDIDO FECHA NA PROPRIA LOJA. Ate 31/08/2026 esta tela montava uma
     mensagem e mandava para o WhatsApp — era o unico canal que existia, porque
     o catalogo morava no `app.js` e nao havia produto para cobrar. Agora as oito
     pecas sao produto de verdade na Shopify, com o SKU igual ao `id` da peca, e
     o botao final monta o carrinho e vai para o pagamento da loja, no mesmo
     dominio deste site.

     Isto NAO contradiz o "nada de checkout falso" da §6.1 do plano — e o oposto
     dele. O que a §6.1 proibe e simular pagamento; o que esta tela faz e
     entregar para o pagamento de verdade, que cobra, emite e registra o pedido.

     O QUE ESTA TELA PERGUNTA E SO O QUE O PAGAMENTO NAO PERGUNTA. Nome, e-mail,
     telefone e endereco completo sao coletados na tela da loja; repetir aqui
     faria a pessoa digitar o mesmo endereco duas vezes. Fica o que nenhum
     checkout de plataforma tem campo para perguntar (§4.4) — portaria, avisar,
     ligar, referencia — e o CEP, que fica de proposito: a §5.5 e dura em dizer
     que descobrir no pagamento que a casa nao entrega no bairro e a pior tela
     possivel. */

  /* A LISTA DA ZONA 1 E A PROPOSTA DA §5.2 DO PLANO, e nada nela foi confirmado
     pela casa. Por isso a tela nomeia a zona e NAO promete prazo nem preco:
     "chega hoje" depende do corte, que e `A CONFIRMAR`, e taxa por zona idem.
     Mudar a area atendida se faz aqui, numa lista, e nao recalculando geometria
     — que e a razao de a §5.1 ter escolhido bairro em vez de raio em km. */
  var ZONA1 = [
    'vila olimpia', 'itaim bibi', 'vila nova conceicao', 'brooklin',
    'brooklin novo', 'brooklin paulista', 'berrini', 'moema', 'campo belo',
    'jardim paulista', 'pinheiros', 'chacara santo antonio'
  ];

  /* A troca de acento vai por TABELA, e nao por `normalize('NFD')` + regex de
     marca combinante. Duas razoes: o regex precisaria de caracteres invisiveis
     literais dentro do arquivo, que somem em qualquer conversao de codificacao;
     e o `normalize` nao existe em navegador antigo, o que faria a comparacao de
     bairro falhar EM SILENCIO e jogar "Vila Olimpia" para a zona 2. */
  var ACENTOS = 'áàâãäéèêëíìîïóòôõöúùûüç';
  var SEM_ACENTO = 'aaaaaeeeeiiiiooooouuuuc';

  function semAcento(s) {
    s = String(s || '').toLowerCase().trim();
    var fora = '';
    for (var i = 0; i < s.length; i++) {
      var p = ACENTOS.indexOf(s.charAt(i));
      fora += p < 0 ? s.charAt(i) : SEM_ACENTO.charAt(p);
    }
    return fora;
  }

  function zonaDe(bairro, cidade, uf) {
    if (semAcento(uf) !== 'sp' || semAcento(cidade) !== 'sao paulo') return 3;
    var b = semAcento(bairro);
    for (var i = 0; i < ZONA1.length; i++) {
      if (b === ZONA1[i] || b.indexOf(ZONA1[i]) === 0) return 1;
    }
    return 2;
  }

  var ZONA_TEXTO = {
    1: ['A vizinhança da casa',
        'A Casa Flores fica na Vila Olímpia e entrega aqui do lado. A janela a casa confirma depois do pedido.'],
    2: ['São Paulo, fora da vizinhança',
        'A casa atende, e confirma a janela desta entrega depois do pedido.'],
    3: ['Fora da área que a casa entrega',
        'A entrega própria não alcança este endereço. Vale falar com a casa antes de pagar.']
  };

  var ckEntrega = { cep: '', bairro: '', cidade: '', uf: '', zona: 0, buscou: false };

  function dataCompleta(iso) {
    var p = String(iso).split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : String(iso);
  }

  function cepBonito(cep) {
    var d = soDigitos(cep);
    return d.length === 8 ? d.slice(0, 5) + '-' + d.slice(5) : cep;
  }

  function soDigitos(s) { return String(s || '').replace(/\D/g, ''); }

  function val(nome) {
    var el = $('[name="' + nome + '"]');
    return el ? String(el.value).trim() : '';
  }

  function marcado(nome) {
    var el = $('[name="' + nome + '"]');
    return !!(el && el.checked);
  }

  function simNao(v) { return v ? 'sim' : 'não'; }

  function paraMim() {
    var el = $('[name="paraquem"]:checked');
    return !el || el.value === 'mim';
  }

  /* ------------------------------------------------------------- a pintura */

  function entregaResumida() {
    var sub = total();
    return (ENTREGA_GRATIS > 0 && sub >= ENTREGA_GRATIS) ? 'por conta da casa' : 'a combinar';
  }

  function pintaCkResumo() {
    var caixa = $('[data-ck-pecas]');
    if (!caixa) return;
    caixa.innerHTML = linhas().map(function (l) {
      var d = [l.data ? dataBonita(l.data) : '', l.janela].filter(Boolean).join(' · ');
      return '' +
        '<div class="resumo__peca">' +
          miniDaPeca(l) +
          '<div><p class="resumo__n">' + esc(l.nome) + '</p>' +
            '<p class="resumo__d">' + (l.qtd > 1 ? l.qtd + ' peças' : '1 peça') +
            (d ? ' · ' + esc(d) : '') + (l.cartao ? ' · com cartão' : '') + '</p></div>' +
          '<span class="resumo__p">' + moeda(l.qtd * l.preco) + '</span>' +
        '</div>';
    }).join('');

    var sub = total();
    var st = $('[data-ck-subtotal]'); if (st) st.textContent = moeda(sub);
    var en = $('[data-ck-entrega]');  if (en) en.textContent = entregaResumida();
    var tt = $('[data-ck-total]');    if (tt) tt.textContent = moeda(sub);
    var ob = $('[data-ck-obs]');
    if (ob) {
      ob.textContent = entregaResumida() === 'a combinar'
        ? 'A entrega é calculada na tela de pagamento, pelo endereço.'
        : 'A entrega desta sacola já está por conta da casa.';
    }
  }

  function pintaZona() {
    var caixa = $('[data-ck-zona]');
    if (!caixa) return;
    if (!ckEntrega.zona) { caixa.innerHTML = ''; return; }
    var z = ZONA_TEXTO[ckEntrega.zona];
    caixa.innerHTML =
      '<div class="zona' + (ckEntrega.zona === 3 ? ' zona--fora' : '') + '">' +
        '<p class="zona__t">' + esc(z[0]) +
          (ckEntrega.bairro ? ' — ' + esc(ckEntrega.bairro) : '') + '</p>' +
        '<p class="zona__d">' + esc(z[1]) + '</p>' +
      '</div>';
  }

  function pintaConfere() {
    var caixa = $('[data-ck-confere]');
    if (!caixa) return;
    var itens = linhas();
    caixa.innerHTML = itens.map(function (l) {
      return '' +
        '<div class="confere">' +
          miniDaPeca(l) +
          '<div>' +
            '<p class="confere__n">' + esc(l.nome) + (l.qtd > 1 ? ' · ' + l.qtd : '') + '</p>' +
            '<dl style="margin:0">' +
              '<div class="confere__l"><dt>Data</dt><dd>' +
                (l.data ? esc(dataBonita(l.data)) : 'a combinar') +
                ' <a class="confere__alterar" href="' + hrefPeca(l.id) + '">alterar</a></dd></div>' +
              '<div class="confere__l"><dt>Janela</dt><dd>' +
                (l.janela ? esc(l.janela) : 'a combinar') +
                ' <a class="confere__alterar" href="' + hrefPeca(l.id) + '">alterar</a></dd></div>' +
            '</dl>' +
            (l.cartao
              ? '<p class="recado"></p>'
              : '<p class="recado recado--sem">Esta peça vai sem cartão. ' +
                '<a class="confere__alterar" href="' + hrefPeca(l.id) + '">escrever um</a></p>') +
          '</div>' +
        '</div>';
    }).join('');

    /* O RECADO SAI BYTE A BYTE (§4.2), entao entra por `textContent` e nunca por
       `innerHTML`: acento, maiuscula e quebra de linha chegam a impressao
       exatamente como estao aqui. */
    $$('.confere', caixa).forEach(function (bloco, n) {
      var p = $('.recado', bloco);
      if (p && itens[n] && itens[n].cartao) p.textContent = itens[n].cartao;
    });

    var aviso = $('[data-ck-aviso-endereco]');
    if (aviso) aviso.classList.toggle('oculto', itens.length < 2);
  }

  /* ------------------------------------------------------------ as etapas */

  function etapa(n) { return $('.etapa[data-etapa="' + n + '"]'); }

  function abreEtapa(n) {
    for (var i = 1; i <= 3; i++) {
      var s = etapa(i);
      if (!s) continue;
      if (i === n) s.setAttribute('data-estado', 'aberto');
      else if (s.getAttribute('data-estado') === 'aberto') s.setAttribute('data-estado', 'fechado');
    }
    if (n === 2) pintaConfere();
    var alvo = etapa(n);
    if (alvo) alvo.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function marcaFeito(n, resumo) {
    var s = etapa(n);
    if (!s) return;
    s.setAttribute('data-estado', 'feito');
    var r = $('[data-ck-resumo="' + n + '"]', s);
    if (r) r.textContent = resumo;
  }

  function erroNo(campo, msg) {
    if (!campo) return;
    campo.setAttribute('data-erro', '');
    var e = $('.campo__e', campo);
    if (!e) {
      e = document.createElement('span');
      e.className = 'campo__e';
      campo.appendChild(e);
    }
    e.textContent = msg;
  }

  function limpaErro(campo) {
    if (!campo) return;
    campo.removeAttribute('data-erro');
    var e = $('.campo__e', campo);
    if (e) e.parentNode.removeChild(e);
  }

  function validaEtapa1() {
    $$('.etapa[data-etapa="1"] .campo').forEach(limpaErro);
    if (soDigitos(val('cep')).length !== 8) {
      erroNo($('[data-campo="cep"]'),
        'O CEP tem oito números. É com ele que a casa sabe se entrega aí antes de você pagar.');
      return false;
    }
    return true;
  }

  /* ---------------------------------------------------------------- o CEP */

  function buscaCep() {
    var cep = soDigitos(ckEntrega.cep);
    var aviso = $('[data-cep-estado]');
    if (cep.length !== 8) { ckEntrega.zona = 0; pintaZona(); return; }
    if (aviso) aviso.textContent = 'Procurando o endereço…';

    /* ViaCEP e servico publico e responde por HTTPS com CORS aberto. Se ele
       cair, a etapa NAO trava: a zona fica sem nome e o pedido segue para o
       pagamento, onde o endereco e pedido de qualquer jeito. Travar o pedido
       porque uma API de terceiro nao respondeu e perder venda por um detalhe
       que a tela seguinte resolve sozinha. */
    var pronto = false;
    function falhou() {
      if (pronto) return;
      pronto = true;
      ckEntrega.buscou = true;
      if (aviso) aviso.textContent = 'Não consegui conferir agora. Dá para seguir: o endereço entra na tela de pagamento.';
    }
    try {
      var req = new XMLHttpRequest();
      req.open('GET', 'https://viacep.com.br/ws/' + cep + '/json/', true);
      req.timeout = 6000;
      req.onload = function () {
        if (pronto) return;
        pronto = true;
        var d = null;
        try { d = JSON.parse(req.responseText); } catch (x) { d = null; }
        ckEntrega.buscou = true;
        if (!d || d.erro) {
          ckEntrega.zona = 0;
          pintaZona();
          if (aviso) aviso.textContent = 'Não achei este CEP. Confira, ou siga — o endereço entra na tela de pagamento.';
          return;
        }
        ckEntrega.bairro = d.bairro || '';
        ckEntrega.cidade = d.localidade || '';
        ckEntrega.uf = d.uf || '';
        ckEntrega.zona = zonaDe(ckEntrega.bairro, ckEntrega.cidade, ckEntrega.uf);
        if (aviso) aviso.textContent = 'A casa usa o CEP para saber a zona da entrega antes de você pagar.';
        pintaZona();
      };
      req.onerror = falhou;
      req.ontimeout = falhou;
      req.send();
    } catch (x) { falhou(); }
  }

  /* ------------------------------------------------- montar o carrinho */

  /* O MAPA SKU -> VARIANTE VEM DA PROPRIA LOJA. O `layout/theme.liquid` publica
     um JSON com o SKU de cada variante, e o SKU de cada produto e o `id` da peca
     no catalogo (`p1`, `p2`...). Nao ha id de variante escrito a mao em lugar
     nenhum: se a casa recriar um produto, o mapa se refaz sozinho na proxima
     carga da pagina. Local, o bloco vem vazio de proposito — o prototipo nao tem
     loja atras, e um mapa inventado faria a pagina parecer que fecha pedido. */
  function variantes() {
    var el = document.getElementById('cf-variantes');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function propriedadesDa(l) {
    /* Propriedade de LINHA, que e exatamente o que o §4.2 pede: a data, a janela
       e o recado viajam com a peca ate a expedicao e a nota, e aparecem no
       pedido da casa peca por peca. O nome de cada uma e o que a florista vai
       ler no painel — nada de chave tecnica. */
    return {
      /* A data vai COM O ANO aqui, e nao no formato curto da tela. Na tela o
         `04/09` esta ao lado da peca e do resto do pedido; no painel da loja a
         propriedade e lida solta, meses depois, num pedido antigo — e "04/09"
         sem ano e a diferenca entre entregar e ligar para perguntar. */
      'Data da entrega': l.data ? dataCompleta(l.data) : 'a combinar',
      'Janela': l.janela || 'a combinar',
      'Recado do cartão': l.cartao || 'vai sem cartão'
    };
  }

  function atributosDoPedido() {
    var a = {
      /* 25/09/2026: todo pedido espera o retorno da casa antes de ir para a bancada. */
      'Confirmação': 'aguardando retorno da Casa Flores',
      'A entrega é para': paraMim() ? 'quem está comprando' : 'outra pessoa',
      'Recebe na portaria ou recepção': simNao(marcado('portaria')),
      'Avisar quem recebe antes': simNao(!marcado('naoavisar')),
      'Pode ligar para quem recebe': simNao(marcado('podeligar'))
    };
    if (ckEntrega.cep) a['CEP conferido no site'] = cepBonito(ckEntrega.cep);
    if (ckEntrega.zona) a['Zona da entrega'] = ZONA_TEXTO[ckEntrega.zona][0] +
      (ckEntrega.bairro ? ' (' + ckEntrega.bairro + ')' : '');
    if (val('ref')) a['Referência para o entregador'] = val('ref');
    if (val('obs')) a['Recado para a casa'] = val('obs');
    return a;
  }

  function mostraErroCk(msg) {
    var e = $('[data-ck-erro]');
    if (!e) return;
    e.textContent = msg;
    e.classList.remove('oculto');
  }

  function limpaErroCk() {
    var e = $('[data-ck-erro]');
    if (e) { e.textContent = ''; e.classList.add('oculto'); }
  }

  function postaJSON(url, corpo, ok, falha) {
    var req = new XMLHttpRequest();
    req.open('POST', url, true);
    req.setRequestHeader('Content-Type', 'application/json');
    req.timeout = 12000;
    req.onload = function () {
      if (req.status >= 200 && req.status < 300) ok(req.responseText);
      else falha(req.status + ' ' + req.responseText);
    };
    req.onerror = function () { falha('sem resposta'); };
    req.ontimeout = function () { falha('demorou demais'); };
    req.send(JSON.stringify(corpo));
  }

  function vaiPagar(botao) {
    limpaErroCk();
    if (!validaEtapa1()) { abreEtapa(1); return; }

    var itens = linhas();
    if (!itens.length) return;

    var mapa = variantes();
    if (!Object.keys(mapa).length) {
      mostraErroCk('Esta é a versão de estudo do site, sem loja atrás: o pagamento roda na Casa Flores publicada.');
      return;
    }
    var semVariante = itens.filter(function (l) { return !mapa[l.id]; });
    if (semVariante.length) {
      mostraErroCk('A loja não achou ' +
        semVariante.map(function (l) { return l.nome; }).join(', ') +
        '. Tire da sacola ou fale com a casa.');
      return;
    }

    if (botao) { botao.disabled = true; botao.textContent = 'Levando para o pagamento…'; }

    function desiste(motivo) {
      if (botao) { botao.disabled = false; botao.textContent = 'Ir para o pagamento'; }
      mostraErroCk('Não consegui levar a sacola para o pagamento (' + motivo +
                   '). Tente de novo em um instante.');
    }

    /* LIMPAR O CARRINHO ANTES DE MONTAR, e nao e detalhe: quem volta do
       pagamento e clica de novo somaria as mesmas pecas ao que ja estava la, e
       pagaria duas vezes a mesma coisa. O carrinho da loja e o espelho da
       sacola do site, nao um segundo lugar onde as coisas se acumulam. */
    postaJSON('/cart/clear.js', {}, function () {
      postaJSON('/cart/add.js', {
        items: itens.map(function (l) {
          return { id: mapa[l.id], quantity: l.qtd, properties: propriedadesDa(l) };
        })
      }, function () {
        postaJSON('/cart/update.js', { attributes: atributosDoPedido() }, function () {
          window.location.href = '/checkout';
        }, desiste);
      }, desiste);
    }, desiste);
  }

  /* ------------------------------------------------------------- arranque */

  function pintaCheckout() {
    var raiz = $('[data-ck]');
    if (!raiz) return;
    var vazio = $('[data-ck-vazio]');
    var tem = linhas().length > 0;

    raiz.classList.toggle('oculto', !tem);
    if (vazio) vazio.classList.toggle('oculto', tem);
    if (!tem) return;

    pintaCkResumo();
    pintaZona();
    pintaConfere();
  }

  function ligaCheckout() {
    var raiz = $('[data-ck]');
    if (!raiz) return;

    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('[data-ck-segue],[data-ck-abre],[data-ck-paga]') : null;
      if (!b) return;

      if (b.hasAttribute('data-ck-paga')) { vaiPagar(b); return; }

      if (b.hasAttribute('data-ck-segue')) {
        var n = Number(b.getAttribute('data-ck-segue'));
        if (n === 1) {
          if (!validaEtapa1()) return;
          var quem = paraMim() ? 'Para mim' : 'Para outra pessoa';
          var z = ckEntrega.zona ? ' · ' + ZONA_TEXTO[ckEntrega.zona][0] : '';
          marcaFeito(1, quem + ' · CEP ' + cepBonito(ckEntrega.cep) + z);
        }
        if (n === 2) {
          var q = linhas().length;
          marcaFeito(2, q + (q > 1 ? ' peças conferidas' : ' peça conferida'));
        }
        abreEtapa(n + 1);
        return;
      }

      if (b.hasAttribute('data-ck-abre')) {
        var alvo = Number(b.getAttribute('data-ck-abre'));
        var s = etapa(alvo);
        if (s && s.getAttribute('data-estado') === 'feito') abreEtapa(alvo);
      }
    });

    raiz.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t.name !== 'cep') return;
      ckEntrega.cep = t.value;
      if (soDigitos(t.value).length === 8) buscaCep();
      else if (ckEntrega.zona) { ckEntrega.zona = 0; pintaZona(); }
    });
  }

  /* ----------------------------------------------------------------- eventos */

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target.closest('[data-poe],[data-mais],[data-menos],[data-tira],[data-abre],[data-fecha],[data-veu]') : null;
    if (!t) return;

    if (t.hasAttribute('data-poe'))   { poe(t.getAttribute('data-poe')); return; }
    if (t.hasAttribute('data-mais'))  { mexe(t.getAttribute('data-mais'), 1); return; }
    if (t.hasAttribute('data-menos')) { mexe(t.getAttribute('data-menos'), -1); return; }
    if (t.hasAttribute('data-tira'))  { tira(t.getAttribute('data-tira')); return; }
    if (t.hasAttribute('data-abre'))  { abre(t.getAttribute('data-abre')); return; }
    if (t.hasAttribute('data-fecha') || t.hasAttribute('data-veu')) { fecha(); }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { fecha(); return; }
    prendeFoco(ev);
  });

  /* -------------------------------------------------------------- arranque */

  function comeca() {
    recolheVazios();
    pintaCategorias();
    pintaDestaques();
    pintaPDP();
    pintaPLP();
    pintaGarantias();
    pintaClientes();
    pintaVideos();
    pintaAvaliacoes();
    pintaSacola();
    pintaCheckout();
    ligaCheckout();
    cabecalho();
    revelacao();
    filmeDoHero();

    /* A largura da cópia depende da fonte que está desenhando o texto. Medir
       com a fonte de sistema e a Work Sans chegar depois deixa a translação
       fora do passo, e o erro aparece como um buraco na emenda a cada volta.
       Uma remedida quando as fontes assentam resolve. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(pintaGarantias);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', comeca);
  else comeca();

  window.CasaFlores = { PECAS: PECAS, CATEGORIAS: CATEGORIAS, moeda: moeda };
})();
